import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select"; // For Select component
import { getcyclelist } from "store/cycle/actions";
import { updatePayment } from "store/Payment/actions";
import { getdistrictlist } from "store/participantdistrict/actions";
import { getbanklist } from "store/banks/actions";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Button,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getParticipantSchemelist } from "store/Payment/actions";
import {
  getParticipantPayment,
  confirmpayment,
  deletePayment,
} from "store/Payment/actions";
// import { getParticipantSchemelist } from "store/Payment/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";

class ParticipantPayments extends Component {
  constructor(props) {
    // this.handleSchemeChange = this.handleSchemeChange.bind(this)
    super(props);
    this.state = {
      nameFilter: "",
      idFilter: "",
      districtFilter: "",
      schemeFilter: "",
      schemeModalOpen: false,
      showReconcileModal: false,
      amountFilter: "",
      discountFilter: "",
      organization_name: "",
      schemepriceFilter: "",
      hoveredSchemeNames: [],
      showDeleteModal: false,
      deleteRowId: null,
      deleteParticipantName: "",
      deleteComment: "",
      showReconcileDetailsModal: false,
      reconcileDate: "", // Date of reconcile
      activeRowId: null,
      paymentConfirmState: {},
      selectedScheme: null,
      CycleList: [],
      ListDistrict: [],
      TaxFilter: "",
      dateFilter: "",
      filtersApplied: false,
      isAnyFilterApplied: false,
      hoveredSchemeNames: [],
      paymentmodeFilter: "",
      dateFilter: "",
      paymentreceivedFilter: "",
      selectedCheckboxes: {},
      tableKey: 0,
      ListBank: [], // From Redux
      GetPayment: [],
      selectedBankAccount: null,
      selectedBankName: "",
      feedbackMessage: "",
      errorMessage: "",
      paymentsettlementFilter: "",
      paymentMethodFilter: "",
      paymentStatusFilter: "",
      finalpayableFilter: "",
      paidamountFilter: "",
      remainingAmountFilter: "",
      payment_received_date: "",
      dateTo: new Date().toISOString().split("T")[0], // Show current date
      dateToActive: false, // Tracks whether the user activated the filter
      filtersApplied: false,
      membershipStatusFilter: "",
      editModalOpen: false,
      selectedRow: null,
      // 🔁 Dedicated "Replace Scheme" action (separate from Edit Payment)
      showReplaceSchemeModal: false,
      replaceSchemeRow: null,
      replaceSchemeOldId: "",
      replaceSchemeNewId: "",
      replaceSchemeActiveOptions: [],
      replaceSchemeNewOptions: [],
      replaceSchemeDiscountAmount: "",
      replaceSchemeTaxDeduction: "",
      replaceSchemeComments: "",
      replaceSchemeCSR: "",
      replaceSchemePaymentStatus: "",
      replaceSchemePaymentSettlement: "",
      replaceSchemePartPaymentAmount: "",
      replaceSchemeRemainingAmount: "",
      replaceSchemePayDate: "",
      replaceSchemePaymentMethod: "",
      replaceSchemePhoto: null,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      feedbackListColumns: [
        {
          text: "Payment ID",
          dataField: "id",
          sort: true,
          hidden: false,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            // backgroundColor: "#87ceeb", // 🌤 sky blue for cells
            textAlign: "center",
          },
          formatter: (cellContent, methodlist) => <>P-{methodlist.id}</>,
          headerFormatter: (column, colIndex) => (
            <>
              <div style={{ textAlign: "center", marginBottom: "5px" }}>
                {column.text}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="text"
                  value={this.state.idFilter}
                  onChange={e => this.handleFilterChange("idFilter", e)}
                  className="form-control"
                />
              </div>
            </>
          ),
        },
        {
          dataField: "participant_name",
          text: "Participant Name",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb",
            textAlign: "left",
          },
          style: {
            textAlign: "left",
          },
          formatter: (cell, row) => (
            <span
              style={{ color: "#0d6efd", cursor: "pointer" }}
              onClick={() => this.openParticipantModal(row)}
            >
              {cell}
            </span>
          ),
          headerFormatter: column => (
            <div style={{ textAlign: "left" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  placeholder={column.text} // ✅ same as “Participant Name”
                  value={this.state.nameFilter}
                  onChange={e => this.handleFilterChange("nameFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "left",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        // {
        //   dataField: "membership_status",
        //   text: "Participant Status",
        //   sort: true,
        //   headerStyle: {
        //     backgroundColor: "#87ceeb", // 🌤 sky blue for header
        //     textAlign: "center",
        //   },
        //   style: {
        //     textAlign: "right",
        //   },
        //   headerFormatter: (column, colIndex) => (
        //     <div style={{ textAlign: "center" }}>
        //       <div>{column.text}</div>
        //       <div style={{ marginTop: "5px" }}>
        //         <input
        //           type="text"
        //           value={this.state.membershipStatusFilter || ""}
        //           onChange={e =>
        //             this.handleFilterChange("membershipStatusFilter", e)
        //           }
        //           className="form-control"
        //           style={{
        //             textAlign: "center",
        //             width: "100px",
        //             margin: "auto",
        //           }}
        //         />
        //       </div>
        //     </div>
        //   ),
        // },
        {
          dataField: "district",
          text: "District",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            textAlign: "center",
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.districtFilter}
                  onChange={e => this.handleFilterChange("districtFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "60px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        // {
        //   dataField: "scheme_count",
        //   text: "Scheme",
        //   sort: true,
        //   headerStyle: {
        //     backgroundColor: "#87ceeb", // 🌤 sky blue for header
        //     textAlign: "center",
        //   },
        //   style: {
        //     textAlign: "right",
        //   },
        //   headerFormatter: (column, colIndex) => (
        //     <div style={{ textAlign: "center" }}>
        //       <div>{column.text}</div>
        //       <div style={{ marginTop: "5px" }}>
        //         <input
        //           type="text"
        //           value={this.state.schemeFilter}
        //           onChange={e => this.handleFilterChange("schemeFilter", e)}
        //           className="form-control"
        //           style={{
        //             textAlign: "center",
        //             width: "100px",
        //             margin: "auto",
        //           }}
        //         />
        //       </div>
        //     </div>
        //   ),
        //   formatter: (cell, row) => (
        //     <div
        //       onClick={() => this.handleSchemeClick(row)}
        //       style={{ cursor: "pointer", textAlign: "center", color: "blue" }}
        //     >
        //       {cell}
        //     </div>
        //   ),
        // },
        {
          dataField: "priceBeforeDiscount",
          text: "Payable",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: cell => this.formatNumber(cell),
          headerFormatter: (column, colIndex) => (
            <div>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.schemepriceFilter}
                  onChange={e =>
                    this.handleFilterChange("schemepriceFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "50px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "discountAmount",
          text: "Discount Amount",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: cell => {
            // Format number with comma as thousands separator
            return cell != null ? Number(cell).toLocaleString() : "-";
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.discountFilter}
                  onChange={e => this.handleFilterChange("discountFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "50px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "taxDeduction",
          text: "Tax",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: cell => {
            const value = parseFloat(cell);
            return value === 0 || isNaN(value) ? "-" : value.toLocaleString();
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.TaxFilter}
                  onChange={e => this.handleFilterChange("TaxFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "50px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "price",
          text: "Final Payable",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: (cell, row) => {
            const price = parseFloat(row.price) || 0;
            const discount = parseFloat(row.discount) || 0;
            const tax = parseFloat(row.tax) || 0;

            const payable = price - discount - tax;

            // Format with comma and 2 decimal places
            return payable.toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            });
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.finalpayableFilter}
                  onChange={e =>
                    this.handleFilterChange("finalpayableFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "40px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "payment_settlement",
          text: "Payment Settlement",
          sort: true,
          headerStyle: {
            backgroundColor: "#d0e2ff", // 🔵 light blue for header
            textAlign: "center",
          },
          style: {
            backgroundColor: "#d0e2ff", // 🔵 light blue for cells
            textAlign: "right",
          },
          formatter: cell => {
            return cell ? cell : "-";
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paymentsettlementFilter}
                  onChange={e =>
                    this.handleFilterChange("paymentsettlementFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "50px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "payment_status",
          text: "Payment Status",
          sort: true,
          headerStyle: {
            backgroundColor: "#d0e2ff", // light blue header
            textAlign: "center",
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paymentStatusFilter}
                  onChange={e =>
                    this.handleFilterChange("paymentStatusFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "50px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
          formatter: (cell, row) => {
            // Conditional color: red if not verified, green if verified
            const color =
              row.payment_reconcile_status === "Verified" ? "green" : "red";

            return (
              <span style={{ color: color, fontWeight: "bold" }}>
                {cell || "-"}
              </span>
            );
          },
          style: { textAlign: "right" }, // remove fixed background
        },

        // {
        //   dataField: "payment_reconcile_status",
        //   text: "Verification Status",
        //   sort: true,
        //   headerStyle: {
        //     backgroundColor: "#d0e2ff", // 🔵 light blue for header
        //     textAlign: "center",
        //   },
        //   style: {
        //     backgroundColor: "#d0e2ff", // 🔵 light blue for cells
        //     textAlign: "center",
        //   },
        //   formatter: (cell, row) => {
        //     const status = row.payment_reconcile_status;

        //     if (status === "Verified") {
        //       return (
        //         <a
        //           href="#"
        //           onClick={e => {
        //             e.preventDefault();
        //             this.handleViewReconcileDetails(row);
        //           }}
        //         >
        //           {status}
        //         </a>
        //       );
        //     }

        //     return (
        //       <span style={{ color: "gray", cursor: "not-allowed" }}>
        //         {status || "-"}
        //       </span>
        //     );
        //   },

        //   headerFormatter: (column, colIndex) => (
        //     <div style={{ textAlign: "center" }}>
        //       <div>{column.text}</div>
        //       <div style={{ marginTop: "5px" }}>
        //         <input
        //           type="text"
        //           value={this.state.reconcileStatusFilter || ""}
        //           onChange={e =>
        //             this.handleFilterChange("reconcileStatusFilter", e)
        //           }
        //           className="form-control"
        //           style={{
        //             textAlign: "center",
        //             width: "120px",
        //             margin: "auto",
        //           }}
        //         />
        //       </div>
        //     </div>
        //   ),
        // },
        {
          dataField: "part_payment_amount",
          text: "Paid Amount",
          sort: true,
          headerStyle: {
            backgroundColor: "#d0e2ff",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#d0e2ff",
            textAlign: "right",
          },

          formatter: (cell, row) => {
            // ✅ Full payment case
            if (row.payment_settlement === "Full") {
              return this.formatNumber(row.price);
            }

            // ✅ Part payment case
            return this.formatNumber(cell);
          },

          headerFormatter: column => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paidamountFilter}
                  onChange={e => this.handleFilterChange("paidamountFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "remaining_amount",
          text: "Remaining Amount",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            textAlign: "right",
          },
          formatter: cell => {
            const value = parseFloat(cell);
            return value === 0 || isNaN(value) ? "-" : value.toLocaleString();
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.remainingAmountFilter}
                  onChange={e =>
                    this.handleFilterChange("remainingAmountFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "50px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "payment_info",
          text: "Payment Mode / Payment Date",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb",
            textAlign: "center",
          },
          style: {
            textAlign: "center",
          },
          formatter: (cell, row) => {
            const receiptUrl = row.photo_url || null;
            const paymentMethod = row.paymentmethod || "-";

            // Decide date
            const dateToShow =
              row.payment_status === "Payment In process"
                ? row.created_at
                : row.paydate;

            let formattedDate = "-";
            if (dateToShow) {
              const d = new Date(dateToShow);
              if (!isNaN(d)) {
                const day = String(d.getDate()).padStart(2, "0");
                const month = d.toLocaleString("en-US", { month: "short" });
                const year = String(d.getFullYear()).slice(-2);
                formattedDate = `${day}-${month}-${year}`;
              }
            }

            return (
              <div className="d-flex flex-column align-items-center">
                {/* 🔹 Payment Mode (hover → Payment Mode) */}
                {receiptUrl ? (
                  <a
                    href={receiptUrl}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center text-decoration-none text-primary"
                    title="Payment Mode" // ✅ hover on slip/mode
                  >
                    <span className="me-1">{paymentMethod}</span>
                    <FaDownload />
                  </a>
                ) : (
                  <span title="Payment Mode">{paymentMethod}</span>
                )}

                {/* 🔹 Payment Date (hover → Payment Date) */}
                <div className="text-muted" title="Payment Date">
                  {formattedDate}
                </div>
              </div>
            );
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>
                <div>Payment Mode</div>
                <div>Payment Date</div>
              </div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paymentInfoFilter}
                  onChange={e =>
                    this.handleFilterChange("paymentInfoFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                  placeholder="Filter"
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "receivedby",
          text: "Payment Received by",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            textAlign: "right",
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paymentreceivedFilter}
                  onChange={e =>
                    this.handleFilterChange("paymentreceivedFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "action_item",
          text: "Action",
          headerStyle: {
            textAlign: "center",
            verticalAlign: "middle",
            minWidth: "140px",
          },
          style: {
            minWidth: "140px",
            textAlign: "center",
          },
          formatter: (cell, row) => {
            const { paymentConfirmState } = this.state;
            const rowState = paymentConfirmState?.[row.id] || {};
            const status =
              row.payment_reconcile_status || rowState.reconcileStatus || "";

            return (
              <div
                className="d-flex flex-row align-items-center justify-content-center"
                style={{ gap: "6px" }}
                onClick={e => e.stopPropagation()}
              >
                {/* Payment Details */}
                <Tooltip title="Payment Details">
                  <Link
                    to={`/payment-scheme-list/${row.participant_id}?payment_id=${row.id}`}
                    onClick={() => {
                      console.log(
                        "Navigating to participant ID:",
                        row.user_id || row.participant_id
                      );
                      this.saveFiltersToSession();
                    }}
                    style={{ textDecoration: "underline", color: "#0000CD" }}
                  >
                    <i
                      className="mdi mdi-credit-card-outline"
                      style={{ fontSize: "16px" }}
                    />
                  </Link>
                </Tooltip>

                {/* ✏️ Edit Button */}
                <Tooltip title="Edit Payment">
                  <i
                    className="mdi mdi-pencil-outline"
                    style={{
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "#28a745",
                    }}
                    onClick={() => this.toggleEditModal(row)}
                  />
                </Tooltip>

                {/* 🔁 Replace Scheme (separate from Edit) */}
                <Tooltip title="Replace Scheme">
                  <i
                    className="mdi mdi-swap-horizontal"
                    style={{
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "#fd7e14",
                    }}
                    onClick={() => this.handleOpenReplaceSchemeModal(row)}
                  />
                </Tooltip>

                {/* Reconcile */}
                <Tooltip title="Set Verification Status">
                  <i
                    className="mdi mdi-checkbox-marked-circle-outline"
                    style={{
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "#0000CD",
                    }}
                    onClick={() => this.handleOpenModal(row.id)}
                  />
                </Tooltip>

                {/* 🗑️ Delete Button */}
                <Tooltip title="Delete Payment">
                  <i
                    className="mdi mdi-delete-outline"
                    style={{
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "#dc3545",
                    }}
                    onClick={() => this.handleDeleteClick(row)}
                  />
                </Tooltip>

                {/* History */}
                <Tooltip title="History">
                  <Link
                    className="fas fa-comment"
                    style={{ fontSize: "16px" }}
                    to={`/${this.state.organization_name}/PaymentHistory/${row.participant_id}`}
                    onClick={e => {
                      e.preventDefault();

                      if (!this.state.organization_name) {
                        console.error("Invalid organization name");
                        return;
                      }

                      this.saveFiltersToSession();
                      const url = `/${this.state.organization_name}/PaymentHistory/${row.participant_id}`;
                      this.props.history.push(url);
                    }}
                  />
                </Tooltip>
              </div>
            );
          },
        },
      ],
    };
  }
  formatNumber = (value, options = {}) => {
    const num = Number(value);
    return !num || num === 0
      ? "-"
      : num.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
          ...options,
        });
  };

  handleCheckboxToggle = rowId => {
    this.setState(prevState => ({
      paymentConfirmState: {
        ...prevState.paymentConfirmState,
        [rowId]: {
          ...prevState.paymentConfirmState[rowId],
          checked: !prevState.paymentConfirmState[rowId]?.checked,
        },
      },
      tableKey: Date.now(), // trigger full re-render of table
    }));
  };

  handleSaveConfirmation = rowId => {
    if (!rowId) {
      console.error("❌ rowId is undefined");
      return;
    }

    this.props.confirmpayment(rowId);

    this.setState(prevState => ({
      paymentConfirmState: {
        ...prevState.paymentConfirmState,
        [rowId]: {
          checked: false,
          confirmed: true,
        },
      },
      tableKey: Date.now(), // 🔁 this will trigger <BootstrapTable> to fully re-render
    }));
  };
  saveFiltersToSession = () => {
    const filtersToSave = {
      nameFilter: this.state.nameFilter,
      idFilter: this.state.idFilter,
      districtFilter: this.state.districtFilter,
      schemeFilter: this.state.schemeFilter,
      schemepriceFilter: this.state.schemepriceFilter,
      discountFilter: this.state.discountFilter,
      TaxFilter: this.state.TaxFilter,
      paymentsettlementFilter: this.state.paymentsettlementFilter,
      paymentStatusFilter: this.state.paymentStatusFilter,
      reconcileStatusFilter: this.state.reconcileStatusFilter,
      paidamountFilter: this.state.paidamountFilter,
      remainingAmountFilter: this.state.remainingAmountFilter,
      finalpayableFilter: this.state.finalpayableFilter,
      dateFilter: this.state.dateFilter,
      paymentreceivedFilter: this.state.paymentreceivedFilter,
      membershipStatusFilter: this.state.membershipStatusFilter,
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      dateToActive: this.state.dateToActive,
    };

    // Add pagination & table data
    const tableState = {
      filters: filtersToSave,
      page: this.state.page,
      pageSize: this.state.pageSize,
      GetPayment: this.state.GetPayment, // current table data
    };

    // Save to session
    sessionStorage.setItem("PaymentTableState", JSON.stringify(tableState));
    sessionStorage.setItem("cameFromScheme", "true"); // origin flag
  };

  // Load filters when page mounts
  loadFiltersFromSession = () => {
    const cameFromScheme = sessionStorage.getItem("cameFromScheme");
    const savedState = sessionStorage.getItem("PaymentTableState");

    if (cameFromScheme && savedState) {
      const parsed = JSON.parse(savedState);

      this.setState(
        {
          ...parsed.filters,
          page: parsed.page,
          pageSize: parsed.pageSize,
          GetPayment: parsed.GetPayment,
        },
        () => {
          // ✅ REMOVE FLAG AFTER STATE IS SET
          sessionStorage.removeItem("cameFromScheme");
          console.log("✅ Filters restored successfully");
        }
      );
    }
  };
  handleOpenModal = rowId => {
    const row = this.state.GetPayment.find(r => r.id === rowId);
    if (!row) return;

    const isVerified = row.payment_reconcile_status === "Verified";

    this.setState({
      showReconcileModal: true,
      activeRowId: rowId,
      activeParticipantName: row.participant_name || "Unknown",

      // Payment info
      activeRowPaymentId: row.id,
      activeRowPayable: row.price || "-",
      activeRowPaidAmount:
        row.part_payment_amount || row.priceBeforeDiscount || "-",
      activeRowPaymentDate: row.paydate || null,
      activeRowPaymentMode: row.paymentmethod || "-",

      // STATUS
      selectedReconcileStatus: row.payment_reconcile_status || "Non-Verified",
      pendingReconcileStatus: row.payment_reconcile_status || null,

      // Schemes
      activeRowSchemes: row.schemes || [],

      // 🔥 PREFILL INTO PENDING FIELDS
      pendingSelectedAccountNumber: isVerified ? row.account_number || "" : "",
      pendingBankName: isVerified ? row.bank_name || "" : "",
      pendingPaymentReceivedDate: isVerified
        ? row.payment_received_date || ""
        : "",
      pendingComments: isVerified ? row.comments || "" : "",
      pendingUploadedImage: isVerified ? row.attachment_url || null : null,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showReconcileModal: false,
      activeRowId: null,
      activeParticipantName: "",
      selectedReconcileStatus: "",
    });
  };
  openParticipantModal = row => {
    this.setState({
      showParticipantModal: true,
      selectedParticipant: row,
    });
  };
  closeParticipantModal = () => {
    this.setState({
      showParticipantModal: false,
      selectedParticipant: null,
    });
  };
  handleReconcileSubmit = () => {
    const {
      pendingReconcileStatus,
      pendingSelectedAccountNumber,
      pendingBankName,
      pendingComments,
      pendingPaymentReceivedDate,
      pendingUploadedImage,
      activeRowId,
    } = this.state;

    if (!pendingReconcileStatus) {
      alert("Please select a verification status.");
      return;
    }

    // Build payload
    const payload = {
      id: activeRowId,
      status: pendingReconcileStatus,
      account_number: pendingSelectedAccountNumber || null,
      bank_name: pendingBankName || null,
      user_id: this.state.user_id,
      comments: pendingComments,
      payment_received_date: pendingPaymentReceivedDate,
    };
    if (pendingUploadedImage) payload.attachment = pendingUploadedImage;

    this.props.confirmpayment(payload);

    // Update saved data after submission
    this.setState({
      activeRowPaymentStatus: pendingReconcileStatus,
      activeRowPaymentReceivedDate: pendingPaymentReceivedDate,
      activeRowAccountNumber: pendingSelectedAccountNumber,
      activeRowBankName: pendingBankName,
      activeRowComments: pendingComments,
      activeRowAttachment: pendingUploadedImage,

      // Reset pending fields
      pendingReconcileStatus: null,
      pendingPaymentReceivedDate: "",
      pendingSelectedAccountNumber: "",
      pendingBankName: "",
      pendingComments: "",
      pendingUploadedImage: null,
    });

    this.handleCloseModal();
    setTimeout(() => this.props.onGetParticipantpayment(), 1000);
  };

  setReconcileStatus = status => {
    const rowId = this.state.activeRowId;

    // Dispatch saga
    this.props.confirmpayment({
      id: this.state.activeRowId, // Pass the active payment ID
      status: status, // Selected status
    });

    // Update UI locally
    this.setState(prevState => {
      const updatedData = prevState.GetPayment.map(item =>
        item.id === rowId ? { ...item, payment_reconcile_status: status } : item
      );

      return {
        GetPayment: updatedData, // ✅ update row status
        paymentConfirmState: {
          ...prevState.paymentConfirmState,
          [rowId]: {
            ...prevState.paymentConfirmState[rowId],
            reconcileStatus: status,
          },
        },
        showReconcileModal: false,
        activeRowId: null,
      };
    });
  };
  handleOpenReconcileModal = payment => {
    this.setState({
      showReconcileModal: true,
      selectedPayment: payment,
      paymentReceived: payment.payment_received || "", // Prefill if data exists
      bankAccountNumber: payment.account_number || "", // Prefill if data exists
      reconcileDate:
        payment.reconcile_date || new Date().toISOString().split("T")[0], // Default to today
    });
  };
  handleCloseReconcileModal = () => {
    this.setState({
      showReconcileModal: false,
      selectedPayment: null,
      paymentReceived: "",
      bankAccountNumber: "",
      reconcileDate: "",
    });
  };

  handleSaveReconcile = () => {
    const {
      selectedPayment,
      paymentReceived,
      bankAccountNumber,
      reconcileDate,
    } = this.state;

    if (!paymentReceived || !bankAccountNumber || !reconcileDate) {
      alert("Please fill in all fields.");
      return;
    }

    const payload = {
      id: selectedPayment.id,
      payment_received: paymentReceived,
      account_number: bankAccountNumber,
      reconcile_date: reconcileDate,
      status: "Verified",
    };

    console.log("Verified Payload:", payload);

    this.props.confirmpayment(payload); // Dispatch the saga

    // Close the modal
    this.handleCloseReconcileModal();
  };

  handleViewReconcileDetails = payment => {
    if (payment.payment_reconcile_status !== "Verified") {
      console.log("Modal not shown for Non-Verified status.");
      return; // Do nothing if the status is not "Verified"
    }

    console.log("Opening Verified Details for Payment:", payment);
    this.setState({
      showReconcileDetailsModal: true,
      selectedPayment: payment,
    });
  };
  handleCloseReconcileDetailsModal = () => {
    this.setState({
      showReconcileDetailsModal: false,
      selectedPayment: null,
    });
  };
  componentDidMount() {
    this.loadFiltersFromSession();

    const {
      onGetBankList,
      onGetDistrictList,
      confirmpayment,
      onGetParticipantSchemelist,
    } = this.props;
    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) return console.error("User ID is missing.");

    // Fetch static data (always)
    onGetBankList(user_id);
    confirmpayment();
    onGetDistrictList(user_id);
    onGetParticipantSchemelist(user_id);
    // Restore table state if coming back from history
    // if (!sessionStorage.getItem("cameFromScheme")) {
    this.fetchData(user_id);
    // }

    // Set organization_name if exists (for history pages)
    const { organization_name } = this.props.match.params || {};
    if (organization_name) {
      this.setState({ organization_name }, () =>
        console.log("Organization name set:", this.state.organization_name)
      );
    }
  }

  // Updated fetchData
  fetchData(user_id) {
    const { onGetParticipantpayment, ongetcyclelist } = this.props;

    // Always call participant payment API
    onGetParticipantpayment();
    console.log("onGetParticipantPayment called with user_id:", user_id);

    // Always call cycle list API
    ongetcyclelist(user_id);
    console.log("ongetcyclelist called with user_id:", user_id);
  }

  handleSchemeChange = event => {
    const selectedScheme = event.target.value;
    console.log("Scheme selected:", selectedScheme);

    this.setState({ selectedScheme }, () => {
      this.applyFilters(); // Call filters after updating state
    });
  };

  componentDidUpdate(prevProps) {
    const { GetPayment, ListBank, CycleList, ListDistrict } = this.props;

    // ✅ Update CycleList when it changes
    if (CycleList !== prevProps.CycleList) {
      console.log("Updated CycleList:", CycleList);
      this.setState({ CycleList });
    }

    // ✅ Update District list when it changes
    if (ListDistrict !== prevProps.ListDistrict) {
      console.log("Updated ListDistrict:", ListDistrict);
      this.setState({ ListDistrict });
    }

    // ✅ Create a map of banks by account_number for quick lookup (only if banks changed)
    let bankMap = {};
    if (ListBank && ListBank !== prevProps.ListBank) {
      console.log("🏦 Banks received in props:", ListBank);
      bankMap = {};
      ListBank.forEach(bank => {
        bankMap[bank.account_number] = bank.name; // Map account_number → bank name
      });
      this.setState({ ListBank });
    } else if (this.state.ListBank) {
      // Reuse from state if not updated
      this.state.ListBank.forEach(bank => {
        bankMap[bank.account_number] = bank.name;
      });
    }

    // ✅ Transform payment data when GetPayment updates
    if (GetPayment !== prevProps.GetPayment) {
      const transformedData = (GetPayment || []).map(payment => ({
        id: payment.id,
        participant_name: payment.participant_name,
        district: payment.district,
        scheme_count: payment.scheme_count,
        scheme_names: payment.scheme_names || [],
        schemes: payment.schemes || [],
        price: payment.price,
        priceBeforeDiscount: payment.priceBeforeDiscount,
        discountAmount: payment.discountAmount,
        taxDeduction: payment.taxDeduction,
        payment_settlement: payment.payment_settlement,
        paymentmethod: payment.paymentmethod,
        attachment_url: payment.attachment_url || payment.attachment, // ✅ include the URL
        payment_status: payment.payment_status,
        part_payment_amount: payment.part_payment_amount,
        remaining_amount: payment.remaining_amount,
        paydate: payment.paydate,
        photo_url: payment.photo_url,
        receivedby: payment.receivedby,
        membership_status: payment.membership_status,
        payment_reconcile_status: payment.payment_reconcile_status || "",
        reconcileStatus: payment.payment_reconcile_status || "",
        account_number: payment.account_number || null,
        bank_name: bankMap[payment.account_number] || "Unknown", // ✅ Lookup from bankMap
        comments: payment.comments,
        csrcomments: payment.csrcomments || payment.csrcomments,
        payment_received_date: payment.payment_received_date,
        added_by_name: payment.added_by_name || "-", // new field
        reconciled_at: payment.reconciled_at || null,
        participant_id: payment.participant_id,
        created_at: payment.created_at,
        cycle_no: payment.cycle_no || "-",
        remaining_round: payment.remaining_round || "-",
      }));

      // Build reconcile status map for quick access
      const paymentConfirmState = {};
      transformedData.forEach(row => {
        paymentConfirmState[row.id] = {
          reconcileStatus: row.reconcileStatus,
        };
      });

      this.setState({
        GetPayment: transformedData,
        paymentConfirmState,
      });
    }
  }

  handleSchemeClick = row => {
    this.setState({
      hoveredSchemeNames: row.scheme_names || [],
      schemeModalOpen: true,
      modalParticipantName: row.participant_name || "", // ✅ Matches modal
    });
  };

  toggleEditModal = (row, participant = null) => {
    const freshCycleList = this.props.CycleList;

    // ✅ If row already has scheme objects with IDs, use them directly
    // 🔁 Only currently-active schemes are editable/pre-selected — replaced
    // schemes stay attached to the payment's history but drop out of the form.
    const matchedSchemes = (row.schemes || [])
      .filter(s => s.status !== "Replaced")
      .map(rowScheme =>
        freshCycleList.find(
          c =>
            String(c.scheme_id) === String(rowScheme.scheme_id) &&
            String(c.id) === String(rowScheme.cycle_id || rowScheme.id)
        )
      )
      .filter(Boolean);

    const scheme_ids = matchedSchemes.map(opt => `${opt.scheme_id}-${opt.id}`);

    const priceBeforeDiscount = matchedSchemes.reduce((sum, scheme) => {
      const raw = scheme?.priceBeforeDiscount || scheme?.price || 0;
      const cleaned = parseFloat(raw.toString().replace(/,/g, ""));
      return sum + (isNaN(cleaned) ? 0 : cleaned);
    }, 0);

    this.setState({
      editModalOpen: true,
      selectedRow: row,
      selectedScheme: scheme_ids,
      selectedParticipant: participant || {
        name: row?.participant_name || "",
        district: row?.district || "",
        id: row?.participant || "",
      },
      selectedPrice: priceBeforeDiscount,
      CycleList: freshCycleList,
    });
  };
  // Build the update payload from the Edit Payment form's Formik values.
  // This is a plain field edit — no scheme-swap detection here. Swapping
  // one scheme for another is a distinct action, see the Replace Scheme
  // flow below.
  buildPaymentPayload = values => {
    const newSchemeIds = values.scheme || [];

    const selectedSchemeDetails = newSchemeIds.map(id => {
      const [scheme_id, cycle_id] = id.split("-");
      return this.state.CycleList.find(
        scheme =>
          String(scheme.scheme_id) === scheme_id &&
          String(scheme.id) === cycle_id
      );
    });

    const totalPriceBeforeDiscount = selectedSchemeDetails.reduce(
      (sum, scheme) => {
        const raw = scheme?.priceBeforeDiscount ?? scheme?.price ?? 0;
        const cleaned = parseFloat(raw.toString().replace(/,/g, ""));
        return sum + (isNaN(cleaned) ? 0 : cleaned);
      },
      0
    );

    const payload = {
      ...values,
      scheme: newSchemeIds.join(","),
      id: this.state.selectedRow?.id,
      added_by: this.state.user_id,
      participant:
        this.state.selectedRow?.participant || values.participant,
      priceBeforeDiscount: parseFloat(
        totalPriceBeforeDiscount.toString().replace(/,/g, "")
      ).toFixed(2),
      csrcomments: values.csrcomments,
    };

    return payload;
  };

  // Dispatches an Edit Payment save and refreshes the table.
  submitPaymentPayload = payload => {
    console.log(
      "✅ Final priceBeforeDiscount to send:",
      payload.priceBeforeDiscount
    );

    this.props.onupdatePayment(payload);

    setTimeout(() => {
      if (this.state.user_id) {
        this.props.onGetParticipantpayment(this.state.user_id);
      }
    }, 500);

    this.setState({ editModalOpen: false });
  };

  // ================= Replace Scheme (separate action from Edit) =================
  // Opens a focused modal: pick the active scheme to retire, pick the new
  // scheme taking its place. No other payment fields are touched here.
  handleOpenReplaceSchemeModal = row => {
    const freshCycleList = this.props.CycleList || this.state.CycleList;

    // Schemes currently active on this payment (excludes anything already
    // marked "Replaced" from a prior swap).
    const activeMatchedSchemes = (row.schemes || [])
      .filter(s => s.status !== "Replaced")
      .map(rowScheme =>
        freshCycleList.find(
          c =>
            String(c.scheme_id) === String(rowScheme.scheme_id) &&
            String(c.id) === String(rowScheme.cycle_id || rowScheme.id)
        )
      )
      .filter(Boolean);

    const activeOptions = activeMatchedSchemes.map(opt => ({
      value: `${opt.scheme_id}-${opt.id}`,
      label: `${opt.scheme_name} (Cycle ${opt.cycle_no})`,
      scheme_id: opt.scheme_id,
      cycle_id: opt.id,
      price: opt.priceBeforeDiscount || opt.price || 0,
    }));

    const activeIds = activeOptions.map(o => o.value);

    // Candidate replacements: any scheme/cycle not already active on this row.
    const newOptions = freshCycleList
      .filter(
        c => !activeIds.includes(`${c.scheme_id}-${c.id}`)
      )
      .map(c => ({
        value: `${c.scheme_id}-${c.id}`,
        label: `${c.scheme_name} (Cycle ${c.cycle_no})`,
        scheme_id: c.scheme_id,
        cycle_id: c.id,
        price: c.priceBeforeDiscount || c.price || 0,
      }));

    this.setState({
      showReplaceSchemeModal: true,
      replaceSchemeRow: row,
      replaceSchemeOldId: "",
      replaceSchemeNewId: "",
      replaceSchemeActiveOptions: activeOptions,
      replaceSchemeNewOptions: newOptions,
      // 🔽 Prefill payable / discount / tax / comments / CSR from the row so
      // the replace form starts from the payment's current values.
      replaceSchemeDiscountAmount: row.discountAmount || "",
      replaceSchemeTaxDeduction: row.taxDeduction || "",
      replaceSchemeComments: row.csrcomments || "",
      replaceSchemeCSR: row.receivedby || "",
      // 🔽 Full payment field set carried forward from the row so the
      // Replace Scheme form starts pre-populated with the current payment.
      replaceSchemePaymentStatus: row.payment_status || "",
      replaceSchemePaymentSettlement: row.payment_settlement || "",
      replaceSchemePartPaymentAmount:
        row.payment_settlement === "Full"
          ? row.price || ""
          : row.part_payment_amount || "",
      replaceSchemeRemainingAmount: row.remaining_amount || "",
      replaceSchemePayDate:
        row.paydate && row.paydate !== "null" ? row.paydate : "",
      replaceSchemePaymentMethod: row.paymentmethod || "",
      replaceSchemePhoto: null,
    });
  };

  handleCloseReplaceSchemeModal = () => {
    this.setState({
      showReplaceSchemeModal: false,
      replaceSchemeRow: null,
      replaceSchemeOldId: "",
      replaceSchemeNewId: "",
      replaceSchemeActiveOptions: [],
      replaceSchemeNewOptions: [],
      replaceSchemeDiscountAmount: "",
      replaceSchemeTaxDeduction: "",
      replaceSchemeComments: "",
      replaceSchemeCSR: "",
      replaceSchemePaymentStatus: "",
      replaceSchemePaymentSettlement: "",
      replaceSchemePartPaymentAmount: "",
      replaceSchemeRemainingAmount: "",
      replaceSchemePayDate: "",
      replaceSchemePaymentMethod: "",
      replaceSchemePhoto: null,
    });
  };

  // Live totals for the Replace Scheme form — recomputes Payable / Final
  // Payable whenever the scheme selection or discount/tax inputs change.
  getReplaceSchemeTotals = () => {
    const {
      replaceSchemeActiveOptions,
      replaceSchemeNewOptions,
      replaceSchemeOldId,
      replaceSchemeNewId,
      replaceSchemeDiscountAmount,
      replaceSchemeTaxDeduction,
    } = this.state;

    const remainingIds = replaceSchemeActiveOptions
      .map(o => o.value)
      .filter(id => id !== replaceSchemeOldId);
    const newSchemeIds = replaceSchemeNewId
      ? [...remainingIds, replaceSchemeNewId]
      : remainingIds;

    const allOptions = [
      ...replaceSchemeActiveOptions,
      ...replaceSchemeNewOptions,
    ];

    const priceBeforeDiscount = newSchemeIds.reduce((sum, id) => {
      const opt = allOptions.find(o => o.value === id);
      const raw = opt?.price || 0;
      const cleaned = parseFloat(raw.toString().replace(/,/g, ""));
      return sum + (isNaN(cleaned) ? 0 : cleaned);
    }, 0);

    const discount = parseFloat(replaceSchemeDiscountAmount) || 0;
    const tax = parseFloat(replaceSchemeTaxDeduction) || 0;
    const finalPrice = priceBeforeDiscount - discount - tax;

    return { priceBeforeDiscount, discount, tax, finalPrice };
  };

  handleConfirmReplaceScheme = () => {
    const {
      replaceSchemeRow,
      replaceSchemeOldId,
      replaceSchemeNewId,
      replaceSchemeActiveOptions,
      replaceSchemeComments,
      replaceSchemeCSR,
      replaceSchemePaymentStatus,
      replaceSchemePaymentSettlement,
      replaceSchemePartPaymentAmount,
      replaceSchemeRemainingAmount,
      replaceSchemePayDate,
      replaceSchemePaymentMethod,
      replaceSchemePhoto,
    } = this.state;

    if (!replaceSchemeRow || !replaceSchemeOldId || !replaceSchemeNewId) {
      alert("Please select both the scheme to replace and its replacement.");
      return;
    }

    // Remaining active schemes (the ones NOT being replaced) plus the new one.
    const remainingIds = replaceSchemeActiveOptions
      .map(o => o.value)
      .filter(id => id !== replaceSchemeOldId);
    const newSchemeIds = [...remainingIds, replaceSchemeNewId];

    const {
      priceBeforeDiscount: totalPriceBeforeDiscount,
      discount,
      tax,
      finalPrice,
    } = this.getReplaceSchemeTotals();

    // Paid Amount to send: full final payable when settlement is Full,
    // otherwise whatever the user entered as the part payment.
    const paidAmount =
      replaceSchemePaymentSettlement === "Full"
        ? finalPrice.toFixed(2)
        : replaceSchemePartPaymentAmount || 0;

    const remainingAmount =
      replaceSchemePaymentSettlement === "Full"
        ? 0
        : replaceSchemeRemainingAmount || 0;

    const payload = {
      id: replaceSchemeRow.id,
      participant: replaceSchemeRow.participant,
      added_by: this.state.user_id,

      // Scheme swap.
      scheme: newSchemeIds.join(","),
      priceBeforeDiscount: totalPriceBeforeDiscount.toFixed(2),
      discountAmount: discount.toFixed(2),
      taxDeduction: tax.toFixed(2),
      price: finalPrice.toFixed(2),

      // Full editable payment field set.
      payment_status: replaceSchemePaymentStatus || replaceSchemeRow.payment_status,
      payment_settlement:
        replaceSchemePaymentSettlement || replaceSchemeRow.payment_settlement,
      part_payment_amount: paidAmount,
      remaining_amount: remainingAmount,
      paymentmethod:
        replaceSchemePaymentMethod || replaceSchemeRow.paymentmethod,
      paydate: replaceSchemePayDate || replaceSchemeRow.paydate,
      receivedby: replaceSchemeCSR || replaceSchemeRow.receivedby,
      csrcomments: replaceSchemeComments,

      // 🔑 Backend uses these to archive the old scheme-assignment row
      // (keeping its payment history intact) instead of overwriting it,
      // and to create a fresh assignment row for the new scheme.
      is_scheme_replacement: true,
      removed_scheme_ids: [replaceSchemeOldId],
      added_scheme_ids: [replaceSchemeNewId],
    };

    // Only attach a new receipt if the user actually uploaded one — otherwise
    // the existing receipt on the payment record stays untouched.
    if (replaceSchemePhoto) {
      payload.photo = replaceSchemePhoto;
    }

    this.props.onupdatePayment(payload);

    setTimeout(() => {
      if (this.state.user_id) {
        this.props.onGetParticipantpayment(this.state.user_id);
      }
    }, 500);

    this.handleCloseReplaceSchemeModal();
  };

  handleDeleteClick = row => {
    this.setState({
      showDeleteModal: true,
      deleteRowId: row.id,
      deleteParticipantName: row.participant_name || "Unknown",
      deleteComment: "",
      deleteRequestedBy: "",
      deleteRowData: row, // ✅ keep the whole row so we can build a full payload later
    });
  };

  handleCloseDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      deleteRowId: null,
      deleteParticipantName: "",
      deleteComment: "",
      deleteRequestedBy: "",
      deleteRowData: null,
    });
  };

  handleConfirmDelete = () => {
    const { deleteRowId, deleteComment, deleteRequestedBy, deleteRowData } =
      this.state;
    if (!deleteRowId || !deleteComment?.trim() || !deleteRequestedBy?.trim())
      return;

    const schemesSnapshot = (deleteRowData?.schemes || []).map(s => ({
      scheme_id: s.scheme_id,
      scheme_name: s.scheme_name,
      cycle_id: s.cycle_id,
      cycle_no: s.cycle_no,
      price: deleteRowData?.priceBeforeDiscount,
      paydate: deleteRowData?.paydate,
    }));

    this.props.ondeletePayment({
      id: deleteRowId,
      comment: deleteComment,
      requested_by_name: deleteRequestedBy, // ← add this

      payment_id: deleteRowData?.id,
      lab_name: deleteRowData?.participant_name || "",
      participant_id: deleteRowData?.participant_id,

      price: deleteRowData?.price,
      priceBeforeDiscount: deleteRowData?.priceBeforeDiscount,
      discountAmount: deleteRowData?.discountAmount,
      taxDeduction: deleteRowData?.taxDeduction,
      payment_settlement: deleteRowData?.payment_settlement,
      part_payment_amount: deleteRowData?.part_payment_amount,
      remaining_amount: deleteRowData?.remaining_amount,
      payment_status: deleteRowData?.payment_status,
      payment_reconcile_status: deleteRowData?.payment_reconcile_status,
      paymentmethod: deleteRowData?.paymentmethod,
      paydate: deleteRowData?.paydate,
      receivedby: deleteRowData?.receivedby,
      account_number: deleteRowData?.account_number,
      bank_name: deleteRowData?.bank_name,
      comments: deleteRowData?.comments,
      payment_received_date: deleteRowData?.payment_received_date,
      added_by_name: deleteRowData?.added_by_name,
      created_at: deleteRowData?.created_at,

      schemes: schemesSnapshot,
    });

    this.setState({
      showDeleteModal: false,
      deleteRowId: null,
      deleteParticipantName: "",
      deleteComment: "",
      deleteRequestedBy: "", // ← add this
      deleteRowData: null,
    });

    setTimeout(() => this.props.onGetParticipantpayment(), 1000);
  };
  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };

  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };

  handleFilterChange = (filterName, e) => {
    const value = e.target.value;

    this.setState(
      prevState => ({
        [filterName]: value,

        dateToActive: filterName === "dateTo" ? true : prevState.dateToActive,
      }),
      this.checkFiltersApplied
    );
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };

  isValidFilter = value => {
    return value && value !== "Select" && value !== "All";
  };

  filterData = () => {
    const {
      GetPayment,
      nameFilter = "Select",
      idFilter = "Select",
      districtFilter = "Select",
      schemeFilter = "Select",
      schemepriceFilter = "Select",
      amountFilter = "Select",
      discountFilter = "Select",
      TaxFilter = "Select",
      paymentsettlementFilter = "Select",
      paymentreceivedFilter = "Select",
      membershipStatusFilter = "Select",
      paymentMethodFilter = "Select",
      paymentStatusFilter = "Select",
      reconcileStatusFilter = "Select",
      paidamountFilter = "Select",
      remainingAmountFilter = "Select",
      finalpayableFilter = "Select",
      dateFilter = "",
      dateFrom,
      dateTo,
      dateToActive, // Include activation flag
    } = this.state;

    // Return empty array if no filters are applied
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
      amountFilter,
      discountFilter,
      TaxFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      reconcileStatusFilter,
      paidamountFilter,
      remainingAmountFilter,
      finalpayableFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive ? dateTo : "", // Only use dateTo if active
    ];
    const isActive = val =>
      val !== undefined &&
      val !== null &&
      val !== "" &&
      val !== "All" &&
      val !== "Select";

    const isAnyFilterApplied = filters.some(f => f && f !== "Select");

    // 🚫 PAGE LOAD → show nothing
    if (!isAnyFilterApplied) return [];

    return GetPayment.filter(entry => {
      // ✅ Participant Name
      if (
        this.isValidFilter(nameFilter) &&
        !entry.participant_name
          ?.toLowerCase()
          .includes(nameFilter.toLowerCase())
      )
        return false;
      // ✅ Scheme filter (CORRECT)
      if (isActive(schemeFilter)) {
        const schemeNames = (entry.schemes || []).map(s => s.scheme_name);

        if (!schemeNames.includes(schemeFilter)) {
          return false;
        }
      }

      // ✅ ID
      if (
        this.isValidFilter(idFilter) &&
        !entry.id?.toString().includes(idFilter)
      )
        return false;

      // ✅ District
      if (
        this.isValidFilter(districtFilter) &&
        !entry.district?.toLowerCase().includes(districtFilter.toLowerCase())
      )
        return false;

      // ✅ Payment Status (EXACT match)
      if (
        this.isValidFilter(paymentStatusFilter) &&
        entry.payment_status !== paymentStatusFilter
      )
        return false;

      // ✅ Payment Settlement (Full / Part — exact)
      if (
        this.isValidFilter(paymentsettlementFilter) &&
        entry.payment_settlement !== paymentsettlementFilter
      )
        return false;

      // ✅ Reconcile Status
      if (this.isValidFilter(reconcileStatusFilter)) {
        const status = entry.payment_reconcile_status;
        const normalizedStatus =
          status === true || status === 1
            ? "Verified"
            : status === false || status === 0
            ? "Non-Verified"
            : status;

        if (normalizedStatus !== reconcileStatusFilter) return false;
      }

      // ✅ Received By
      if (
        this.isValidFilter(paymentreceivedFilter) &&
        !entry.receivedby
          ?.toLowerCase()
          .includes(paymentreceivedFilter.toLowerCase())
      )
        return false;

      // ✅ Date filters
      if (dateFrom && new Date(entry.paydate) < new Date(dateFrom))
        return false;

      if (dateToActive && new Date(entry.paydate) > new Date(dateTo))
        return false;

      // ================= FIXED NUMERIC FILTERS =================

      // Payable (before discount)
      if (
        this.isValidFilter(schemepriceFilter) &&
        !String(entry.priceBeforeDiscount || "").includes(schemepriceFilter)
      ) {
        return false;
      }

      // Discount Amount
      if (
        this.isValidFilter(discountFilter) &&
        !String(entry.discountAmount || "").includes(discountFilter)
      ) {
        return false;
      }

      // Tax
      if (
        this.isValidFilter(TaxFilter) &&
        !String(entry.taxDeduction || "").includes(TaxFilter)
      ) {
        return false;
      }

      // Paid Amount
      if (
        this.isValidFilter(paidamountFilter) &&
        !String(entry.part_payment_amount || "").includes(paidamountFilter)
      ) {
        return false;
      }

      // Final Payable (CALCULATED SAME AS UI)
      const price = parseFloat(entry.priceBeforeDiscount) || 0;
      const discount = parseFloat(entry.discountAmount) || 0;
      const tax = parseFloat(entry.taxDeduction) || 0;

      const finalPayable = price - discount - tax;

      if (
        this.isValidFilter(finalpayableFilter) &&
        !finalPayable.toString().includes(finalpayableFilter)
      ) {
        return false;
      }

      // Remaining Amount (API VALUE — NOT RECALCULATED)
      if (
        this.isValidFilter(remainingAmountFilter) &&
        !String(entry.remaining_amount || "").includes(remainingAmountFilter)
      ) {
        return false;
      }

      return true;
    });
  };

  getUniqueOptions = fieldName => {
    const { GetPayment } = this.state;
    const options = new Set();

    GetPayment.forEach(item => {
      const value = item[fieldName];
      if (Array.isArray(value)) {
        value.forEach(v => options.add(v));
      } else if (value) {
        options.add(value);
      }
    });

    return Array.from(options);
  };

  checkFiltersApplied = () => {
    const {
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
      amountFilter,
      discountFilter,
      TaxFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      paidamountFilter,
      remainingAmountFilter,
      finalpayableFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive, // Include activation flag
    } = this.state;

    // Check if ANY filter is applied AND has a NON-EMPTY value
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
      amountFilter,
      discountFilter,
      TaxFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      paidamountFilter,
      remainingAmountFilter,
      finalpayableFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive ? "active" : "", // Only consider dateTo if active
    ];

    const anyFilterSelected = filters.some(f => f && f.trim() !== "");

    this.setState({ filtersApplied: anyFilterSelected });
  };

  getVerifiedPaymentsForParticipant = () => {
    const { GetPayment, activeRowId } = this.state;

    // find active payment row
    const activePayment = GetPayment.find(p => p.id === activeRowId);
    if (!activePayment) return [];

    return GetPayment.filter(
      p =>
        p.participant_id === activePayment.participant_id &&
        p.payment_reconcile_status === "Verified"
    );
  };

  exportToExcel = () => {
    const filteredData = this.filterData();

    if (!filteredData || filteredData.length === 0) {
      alert("No data available to export!");
      return;
    }

    const selectedFields = [
      { label: "Participant Name", key: "participant_name" },
      { label: "District", key: "district" },

      { label: "Payable (Before Discount)", key: "priceBeforeDiscount" },
      { label: "Discount Amount", key: "discountAmount" },
      { label: "Tax Deduction", key: "taxDeduction" },
      { label: "Final Payable", key: "price" },

      { label: "Payment Settlement", key: "payment_settlement" },
      { label: "Paid Amount", key: "part_payment_amount" },
      { label: "Remaining Amount", key: "remaining_amount" },

      { label: "Payment Status", key: "payment_status" },
      { label: "Verification Status", key: "payment_reconcile_status" },

      { label: "Payment Mode", key: "paymentmethod" },
      { label: "Payment Date", key: "paydate" },
      { label: "Received By", key: "receivedby" },
    ];

    const formattedData = filteredData.map(row => {
      const obj = {};

      selectedFields.forEach(field => {
        let value = row[field.key];

        // Handle arrays (if any)
        if (Array.isArray(value)) value = value.join(", ");

        // Handle date formatting
        if (
          field.key === "paydate" ||
          field.key === "payment_received_date" ||
          field.key === "reconciled_at"
        ) {
          value = value
            ? new Date(value).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "";
        }

        // Default null/undefined to empty
        if (value === null || value === undefined) value = "";

        obj[field.label] = value;
      });

      return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Auto column width adjustment
    const colWidths = Object.keys(formattedData[0]).map(key => ({
      wch:
        Math.max(
          key.length,
          ...formattedData.map(row =>
            row[key] ? row[key].toString().length : 0
          )
        ) + 2,
    }));

    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    const fileName = `ParticipantPayments_${
      new Date().toISOString().split("T")[0]
    }.xlsx`;

    saveAs(fileData, fileName);
  };

  render() {
    const schemeOptionsFromData = [
      ...new Set(
        (this.state.GetPayment || []).flatMap(row =>
          (row.schemes || []).map(s => s.scheme_name)
        )
      ),
    ];
    const { GetPayment } = this.state;
    const { CycleList } = this.state;
    const { ListDistrict } = this.state;
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const isAlreadyVerified = this.state.selectedReconcileStatus === "Verified";
    const { editModalOpen, selectedRow } = this.state;
    const schemeOptions = CycleList.map(scheme => ({
      value: `${scheme.scheme_id}-${scheme.id}`,
      label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${scheme.cycle_no})`,
      scheme_id: scheme.scheme_id,
      cycle_id: scheme.id,
      price: parseFloat(
        (scheme.priceBeforeDiscount || scheme.price || "0")
          .toString()
          .replace(/,/g, "")
      ),
    }));
    const csrOptions = (this.props.CSRList || []).map(username => ({
      value: username,
      label: username,
    }));
    console.log("CycleList:", CycleList);
    console.log("Generated schemeOptions:", schemeOptions);
    const verifiedPaymentIds = this.getVerifiedPaymentsForParticipant().map(
      p => p.id
    );

    const filteredSchemes = (this.state.activeRowSchemes || []).filter(
      () => !verifiedPaymentIds.includes(this.state.activeRowPaymentId)
    );

    const filteredData = this.filterData();
    const participant = this.state.selectedParticipant;

    console.log("FULL participant object:", participant);

    // ✅ Use the backend-provided schemes array directly
    const schemes = participant?.schemes || [];
    const schemeCount = schemes.length;
    const pageOptions = {
      sizePerPage: 50,
      totalSize: filteredData.length || GetPayment.length,
      custom: true,
      page: 1,
    };

    const districtOptions = ListDistrict.map(district => ({
      value: district.name,
      label: district.name,
    }));

    console.log("District Options:", districtOptions); // ✅ Console log added here

    const customStyles = {
      // <- This is invalid here
      control: provided => ({
        ...provided,
        minHeight: "38px",
      }),
    };

    // 🔽 Live totals for the Replace Scheme modal (Payable / Final Payable)
    const replaceSchemeTotals = this.getReplaceSchemeTotals();

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Participant Payment | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs
              title="Labs"
              breadcrumbItem="Participant-Payment Record"
            />
            <Row className="justify-content-center align-item-center">
              <p>
                <strong>Note:</strong> Payment Status is displayed in red if the
                payment is not verified, and green if verified
              </p>

              <Col lg="12">
                {" "}
                {/* <p>
                  <strong>Note:</strong> Click on Scheme Number to get detail of
                  each participants payments
                </p> */}
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={filteredData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.feedbackListColumns}
                          data={filteredData}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Modal
                                isOpen={this.state.schemeModalOpen}
                                toggle={this.handleSchemeModalClose}
                              >
                                <ModalHeader
                                  toggle={this.handleSchemeModalClose}
                                >
                                  Scheme Details for{" "}
                                  {this.state.modalParticipantName || "Unknown"}{" "}
                                  {/* 👈 use this instead */}
                                </ModalHeader>

                                <ModalBody>
                                  <ul>
                                    {this.state.hoveredSchemeNames.map(
                                      (name, index) => (
                                        <li key={index}>{name}</li>
                                      )
                                    )}
                                  </ul>
                                </ModalBody>
                              </Modal>
                              <Modal
                                isOpen={this.state.showParticipantModal}
                                toggle={this.closeParticipantModal}
                                centered
                                size="lg"
                              >
                                <ModalHeader
                                  toggle={this.closeParticipantModal}
                                >
                                  <div>
                                    <div style={{ fontWeight: 600 }}>
                                      {this.state.selectedParticipant
                                        ?.participant_name ||
                                        "Participant Details"}
                                    </div>

                                    <div style={{ fontSize: "0.9rem" }}>
                                      Status:{" "}
                                      <span
                                        style={{
                                          fontWeight: 500,
                                          color:
                                            this.state.selectedParticipant
                                              ?.membership_status === "Active"
                                              ? "green"
                                              : this.state.selectedParticipant
                                                  ?.membership_status ===
                                                "Suspended"
                                              ? "red"
                                              : "#6c757d",
                                        }}
                                      >
                                        {this.state.selectedParticipant
                                          ?.membership_status || "-"}
                                      </span>
                                    </div>
                                  </div>
                                </ModalHeader>

                                <h5 className="ms-3">Scheme Details:</h5>

                                <ModalBody>
                                  <table className="table table-bordered table-sm mb-0 text-center">
                                    <thead>
                                      <tr>
                                        <th>Scheme Name</th>
                                        <th>Cycle No</th>
                                        <th>Remaining Rounds</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {schemes.length > 0 ? (
                                        schemes.map((scheme, index) => (
                                          <tr
                                            key={index}
                                            style={
                                              scheme.status === "Replaced"
                                                ? { color: "#999" }
                                                : {}
                                            }
                                          >
                                            <td>{scheme.scheme_name}</td>
                                            <td>{scheme.cycle_no || "-"}</td>
                                            <td>
                                              {scheme.status === "Replaced"
                                                ? "Replaced"
                                                : scheme.remaining_round}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="3">No Schemes Found</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </ModalBody>
                              </Modal>
                              <Modal
                                isOpen={this.state.editModalOpen}
                                toggle={this.toggleEditModal}
                                size="md"
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({ editModalOpen: false })
                                  }
                                >
                                  Update Payment for{" "}
                                  {this.state.selectedRow?.participant_name ||
                                    "Unknown"}
                                </ModalHeader>

                                <ModalBody>
                                  {this.state.selectedRow && (
                                    <Formik
                                      initialValues={{
                                        participant_name:
                                          this.state.selectedRow
                                            .participant_name,
                                        // scheme: [],
                                        scheme: this.state.selectedScheme,
                                        participant:
                                          this.state.selectedParticipant?.id ||
                                          "",
                                        // scheme: [],
                                        district:
                                          this.state.selectedParticipant
                                            ?.district || "",
                                        membership_status:
                                          this.state.selectedRow
                                            .membership_status,
                                        priceBeforeDiscount:
                                          this.state.selectedPrice,
                                        discountAmount:
                                          this.state.selectedRow.discountAmount,
                                        discount:
                                          this.state.selectedRow
                                            ?.discountAmount &&
                                          this.state.selectedPrice
                                            ? (
                                                (parseFloat(
                                                  this.state.selectedRow
                                                    .discountAmount
                                                ) *
                                                  100) /
                                                parseFloat(
                                                  this.state.selectedPrice
                                                )
                                              ).toFixed(2)
                                            : "",
                                        taxDeduction:
                                          this.state.selectedRow.taxDeduction,
                                        price: this.state.selectedRow.price,
                                        payment_settlement:
                                          this.state.selectedRow
                                            .payment_settlement,
                                        part_payment_amount:
                                          this.state.selectedRow
                                            .part_payment_amount,
                                        remaining_amount:
                                          this.state.selectedRow
                                            .remaining_amount,
                                        paymentmethod:
                                          this.state.selectedRow.paymentmethod,
                                        payment_status:
                                          this.state.selectedRow.payment_status,
                                        paydate:
                                          this.state.selectedRow?.paydate &&
                                          this.state.selectedRow.paydate !==
                                            "null"
                                            ? this.state.selectedRow.paydate
                                            : "",
                                        receivedby:
                                          this.state.selectedRow.receivedby,
                                        csrcomments:
                                          this.state.selectedRow.csrcomments ||
                                          this.state.selectedRow.csrcomments ||
                                          "",
                                      }}
                                      onSubmit={(values, { setSubmitting }) => {
                                        const payload = this.buildPaymentPayload(
                                          values
                                        );
                                        setSubmitting(false);
                                        this.submitPaymentPayload(payload);
                                      }}
                                    >
                                      {({
                                        values,
                                        setFieldValue,
                                        isSubmitting,
                                        errors,
                                        touched,
                                      }) => (
                                        <Form>
                                          {/* {(() => {
                                            if (
                                              values.scheme &&
                                              values.scheme.length > 0
                                            ) {
                                              const selectedSchemeDetails =
                                                values.scheme.map(id => {
                                                  const [scheme_id, cycle_id] =
                                                    id.split("-");
                                                  return this.state.CycleList.find(
                                                    scheme =>
                                                      String(
                                                        scheme.scheme_id
                                                      ) === scheme_id &&
                                                      String(scheme.id) ===
                                                        cycle_id
                                                  );
                                                });

                                              const total =
                                                selectedSchemeDetails.reduce(
                                                  (sum, scheme) => {
                                                    return (
                                                      sum +
                                                      (scheme?.price
                                                        ? parseFloat(
                                                            scheme.price
                                                          )
                                                        : 0)
                                                    );
                                                  },
                                                  0
                                                );

                                              if (
                                                values.priceBeforeDiscount !==
                                                total.toFixed(2)
                                              ) {
                                                setFieldValue(
                                                  "priceBeforeDiscount",
                                                  total.toFixed(2)
                                                );
                                                setFieldValue(
                                                  "price",
                                                  total.toFixed(2)
                                                ); // Optional: update final payable
                                              }
                                            }
                                          })()} */}
                                          <Row>
                                            {/* <Col md="6">
                                              <Label>Participant Name</Label>
                                              <Field
                                                name="participant_name"
                                                className="form-control"
                                              />
                                            </Col> */}
                                            <Row>
                                              <Col>
                                                <Label>Scheme</Label>
                                                <Select
                                                  name="scheme"
                                                  isMulti
                                                  options={schemeOptions}
                                                  placeholder={
                                                    this.state.selectedRow?.scheme_names?.join(
                                                      ", "
                                                    ) || "Select schemes"
                                                  }
                                                  value={schemeOptions.filter(
                                                    option =>
                                                      (
                                                        values.scheme || []
                                                      ).includes(option.value)
                                                  )}
                                                  onChange={selectedOptions => {
                                                    const selectedValues =
                                                      selectedOptions
                                                        ? selectedOptions.map(
                                                            option =>
                                                              option.value
                                                          )
                                                        : [];
                                                    setFieldValue(
                                                      "scheme",
                                                      selectedValues
                                                    );

                                                    // ✅ Calculate total price from selected schemes
                                                    const total =
                                                      selectedOptions.reduce(
                                                        (sum, option) => {
                                                          const raw =
                                                            option.price || 0;
                                                          const num =
                                                            parseFloat(
                                                              raw
                                                                .toString()
                                                                .replace(
                                                                  /,/g,
                                                                  ""
                                                                )
                                                            );
                                                          return (
                                                            sum +
                                                            (isNaN(num)
                                                              ? 0
                                                              : num)
                                                          );
                                                        },
                                                        0
                                                      );

                                                    // ✅ Set both base and final price correctly
                                                    setFieldValue(
                                                      "priceBeforeDiscount",
                                                      total.toFixed(2)
                                                    ); // <- this was missing
                                                    const discount =
                                                      parseFloat(
                                                        values.discountAmount
                                                      ) || 0;
                                                    const tax =
                                                      parseFloat(
                                                        values.taxDeduction
                                                      ) || 0;
                                                    const finalPayable =
                                                      total - discount - tax;

                                                    setFieldValue(
                                                      "price",
                                                      finalPayable.toFixed(2)
                                                    );
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                            <Col>
                                              <div className="mb-3">
                                                <Label
                                                  htmlFor="priceBeforeDiscount"
                                                  className="form-label"
                                                >
                                                  Payable
                                                </Label>
                                                <Field name="priceBeforeDiscount">
                                                  {({ field }) => {
                                                    const value = Number(
                                                      (
                                                        values.priceBeforeDiscount ||
                                                        "0"
                                                      )
                                                        .toString()
                                                        .replace(/,/g, "")
                                                    );
                                                    return (
                                                      <input
                                                        {...field}
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                          typeof value ===
                                                          "number"
                                                            ? value.toLocaleString(
                                                                "en-PK"
                                                              )
                                                            : value
                                                        }
                                                        readOnly
                                                        style={{
                                                          backgroundColor:
                                                            "#e9ecef",
                                                        }}
                                                      />
                                                    );
                                                  }}
                                                </Field>
                                                <ErrorMessage
                                                  name="priceBeforeDiscount"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row className="mt-3">
                                            {/* <Col md="6">
                                              <Label>Membership Status</Label>
                                              <Field
                                                name="membership_status"
                                                className="form-control"
                                              />
                                            </Col> */}
                                            <Col md={6}>
                                              <Label>Discount in (%)</Label>
                                              <Field name="discount">
                                                {({ field }) => (
                                                  <input
                                                    {...field}
                                                    type="text"
                                                    className="form-control"
                                                    onChange={e => {
                                                      const discountPercent =
                                                        parseFloat(
                                                          e.target.value
                                                        );
                                                      setFieldValue(
                                                        "discount",
                                                        e.target.value
                                                      );

                                                      // Always read original price from priceBeforeDiscount only
                                                      const basePrice =
                                                        parseFloat(
                                                          values.priceBeforeDiscount
                                                        ) || 0;

                                                      if (
                                                        !isNaN(discountPercent)
                                                      ) {
                                                        const discountAmount =
                                                          (basePrice *
                                                            discountPercent) /
                                                          100;
                                                        const tax = parseFloat(
                                                          values.taxDeduction ||
                                                            0
                                                        );
                                                        const finalPrice =
                                                          basePrice -
                                                          discountAmount -
                                                          tax;

                                                        setFieldValue(
                                                          "discountAmount",
                                                          discountAmount.toFixed(
                                                            2
                                                          )
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          finalPrice.toFixed(2)
                                                        );
                                                      } else {
                                                        // If cleared, also clear discountAmount
                                                        setFieldValue(
                                                          "discountAmount",
                                                          ""
                                                        );
                                                        const tax = parseFloat(
                                                          values.taxDeduction ||
                                                            0
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          (
                                                            basePrice - tax
                                                          ).toFixed(2)
                                                        );
                                                      }
                                                    }}
                                                  />
                                                )}
                                              </Field>
                                              <ErrorMessage
                                                name="discount"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </Col>

                                            <Col md={6}>
                                              <Label>
                                                Discount Amount (Rs)
                                              </Label>
                                              <Field name="discountAmount">
                                                {({ field }) => (
                                                  <input
                                                    {...field}
                                                    type="text"
                                                    className="form-control"
                                                    value={field.value || ""}
                                                    onChange={e => {
                                                      const discountAmount =
                                                        parseFloat(
                                                          e.target.value
                                                        );
                                                      setFieldValue(
                                                        "discountAmount",
                                                        e.target.value
                                                      );

                                                      const payableBeforeDiscount =
                                                        parseFloat(
                                                          values.priceBeforeDiscount ||
                                                            values.price
                                                        ) || 0;

                                                      if (
                                                        !isNaN(
                                                          discountAmount
                                                        ) &&
                                                        payableBeforeDiscount >
                                                          0
                                                      ) {
                                                        const percent =
                                                          (discountAmount /
                                                            payableBeforeDiscount) *
                                                          100;
                                                        const tax = parseFloat(
                                                          values.taxDeduction ||
                                                            0
                                                        );
                                                        const finalPrice =
                                                          payableBeforeDiscount -
                                                          discountAmount -
                                                          tax;

                                                        setFieldValue(
                                                          "discount",
                                                          percent.toFixed(2)
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          finalPrice.toFixed(2)
                                                        );
                                                      } else {
                                                        // If cleared, also clear discount percent
                                                        setFieldValue(
                                                          "discount",
                                                          ""
                                                        );
                                                        const tax = parseFloat(
                                                          values.taxDeduction ||
                                                            0
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          (
                                                            payableBeforeDiscount -
                                                            tax
                                                          ).toFixed(2)
                                                        );
                                                      }
                                                    }}
                                                  />
                                                )}
                                              </Field>
                                              <ErrorMessage
                                                name="discountAmount"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </Col>

                                            <Row>
                                              <Col>
                                                <Label>
                                                  Tax Deduction Amount
                                                </Label>
                                                <Field name="taxDeduction">
                                                  {({ field }) => (
                                                    <input
                                                      {...field}
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Enter tax deduction amount"
                                                      onChange={e => {
                                                        const tax = parseFloat(
                                                          e.target.value
                                                        );
                                                        setFieldValue(
                                                          "taxDeduction",
                                                          e.target.value
                                                        );

                                                        const payable =
                                                          parseFloat(
                                                            values.priceBeforeDiscount ||
                                                              values.price
                                                          ) || 0;
                                                        const discount =
                                                          parseFloat(
                                                            values.discountAmount
                                                          ) || 0;
                                                        if (!isNaN(tax)) {
                                                          const finalPrice =
                                                            payable -
                                                            discount -
                                                            tax;
                                                          setFieldValue(
                                                            "price",
                                                            finalPrice.toFixed(
                                                              2
                                                            )
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  )}
                                                </Field>
                                                <ErrorMessage
                                                  name="taxDeduction"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </Col>
                                              <Row>
                                                <Col>
                                                  <Label>Payment Status</Label>
                                                  <Select
                                                    name="payment_status"
                                                    options={[
                                                      {
                                                        value: "Paid",
                                                        label: "Paid",
                                                      },
                                                      {
                                                        value:
                                                          "Payment In process",
                                                        label:
                                                          "Payment In process",
                                                      },
                                                    ]}
                                                    onChange={selectedOption => {
                                                      const status =
                                                        selectedOption?.value ||
                                                        "";
                                                      setFieldValue(
                                                        "payment_status",
                                                        status
                                                      );

                                                      if (
                                                        status === "Paid" ||
                                                        status ===
                                                          "Payment In process"
                                                      ) {
                                                        setFieldValue(
                                                          "is_active",
                                                          true
                                                        );
                                                      }
                                                    }}
                                                    value={
                                                      values.payment_status
                                                        ? {
                                                            value:
                                                              values.payment_status,
                                                            label:
                                                              values.payment_status,
                                                          }
                                                        : null
                                                    }
                                                    placeholder="Select"
                                                    className={
                                                      errors.payment_status &&
                                                      touched.payment_status
                                                        ? "is-invalid"
                                                        : ""
                                                    }
                                                  />
                                                  <ErrorMessage
                                                    name="payment_status"
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </Col>
                                                {values.payment_status ===
                                                  "Payment In process" && (
                                                  <div className="form-group">
                                                    <label>
                                                      Upload Copy of Purchase
                                                      Order
                                                    </label>
                                                    <input
                                                      type="file"
                                                      name="purchase_order_copy"
                                                      onChange={event =>
                                                        setFieldValue(
                                                          "purchase_order_copy",
                                                          event.currentTarget
                                                            .files[0]
                                                        )
                                                      }
                                                      className="form-control"
                                                    />
                                                    {errors.purchase_order_copy &&
                                                      touched.purchase_order_copy && (
                                                        <div className="text-danger">
                                                          {
                                                            errors.purchase_order_copy
                                                          }
                                                        </div>
                                                      )}
                                                  </div>
                                                )}
                                              </Row>
                                              {values.payment_status ===
                                                "Paid" && (
                                                <>
                                                  <Row>
                                                    <Col>
                                                      <div className="mb-3">
                                                        <Label
                                                          htmlFor="price"
                                                          className="form-label"
                                                        >
                                                          Payable after Discount
                                                          & Tax Deduction
                                                        </Label>
                                                        <Field name="price">
                                                          {({ field }) => (
                                                            <input
                                                              {...field}
                                                              type="text"
                                                              className="form-control"
                                                              value={new Intl.NumberFormat(
                                                                "en-PK",
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    "PKR",
                                                                }
                                                              ).format(
                                                                values.price ||
                                                                  0
                                                              )}
                                                              readOnly
                                                              style={{
                                                                backgroundColor:
                                                                  "#e9ecef",
                                                              }}
                                                            />
                                                          )}
                                                        </Field>
                                                        <ErrorMessage
                                                          name="price"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </div>
                                                    </Col>
                                                  </Row>

                                                  <Col>
                                                    <Label>
                                                      Payment Settlement
                                                    </Label>
                                                    <Select
                                                      name="payment_settlement"
                                                      options={[
                                                        {
                                                          value: "Full",
                                                          label: "Full",
                                                        },
                                                        {
                                                          value: "Part",
                                                          label: "Part",
                                                        },
                                                      ]}
                                                      onChange={selectedOption => {
                                                        const settlement =
                                                          selectedOption?.value ||
                                                          "";
                                                        setFieldValue(
                                                          "payment_settlement",
                                                          settlement
                                                        );
                                                        if (
                                                          settlement ===
                                                            "Full" ||
                                                          settlement === "Part"
                                                        ) {
                                                          setFieldValue(
                                                            "is_active",
                                                            true
                                                          );
                                                        }
                                                      }}
                                                      value={
                                                        values.payment_settlement
                                                          ? {
                                                              value:
                                                                values.payment_settlement,
                                                              label:
                                                                values.payment_settlement,
                                                            }
                                                          : null
                                                      }
                                                      placeholder="Select"
                                                      className={
                                                        errors.payment_settlement &&
                                                        touched.payment_settlement
                                                          ? "is-invalid"
                                                          : ""
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="payment_settlement"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>

                                                  {values.payment_settlement ===
                                                    "Part" && (
                                                    <>
                                                      <Col className="mt-3">
                                                        <Label>
                                                          Part Payment Amount
                                                        </Label>
                                                        <Field name="part_payment_amount">
                                                          {({ field }) => (
                                                            <input
                                                              {...field}
                                                              type="number"
                                                              className={
                                                                errors.part_payment_amount &&
                                                                touched.part_payment_amount
                                                                  ? "form-control is-invalid"
                                                                  : "form-control"
                                                              }
                                                              value={
                                                                field.value ===
                                                                  undefined ||
                                                                field.value ===
                                                                  null ||
                                                                field.value ===
                                                                  ""
                                                                  ? 0
                                                                  : field.value
                                                              }
                                                              onChange={e => {
                                                                const input =
                                                                  e.target
                                                                    .value;
                                                                const partAmount =
                                                                  parseFloat(
                                                                    input
                                                                  ) || 0;
                                                                const totalAmount =
                                                                  parseFloat(
                                                                    values.price
                                                                  ) || 0;
                                                                const remaining =
                                                                  totalAmount -
                                                                  partAmount;

                                                                setFieldValue(
                                                                  "part_payment_amount",
                                                                  input === ""
                                                                    ? 0
                                                                    : input
                                                                );
                                                                setFieldValue(
                                                                  "remaining_amount",
                                                                  remaining >= 0
                                                                    ? remaining
                                                                    : 0
                                                                );
                                                              }}
                                                            />
                                                          )}
                                                        </Field>
                                                        <ErrorMessage
                                                          name="part_payment_amount"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </Col>

                                                      <Col className="mt-3">
                                                        <Label>
                                                          Remaining Amount
                                                        </Label>
                                                        <Field
                                                          name="remaining_amount"
                                                          type="number"
                                                          disabled
                                                          className="form-control"
                                                        />
                                                      </Col>
                                                    </>
                                                  )}
                                                  <Row>
                                                    <Col>
                                                      <Label>Pay Date</Label>
                                                      <Field
                                                        name="paydate"
                                                        type="date"
                                                        className="form-control"
                                                      />
                                                      <ErrorMessage
                                                        name="paydate"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </Col>
                                                  </Row>

                                                  <Row>
                                                    <Col>
                                                      <Label>Pay Copy</Label>
                                                      <Input
                                                        id="formFile"
                                                        name="photo"
                                                        type="file"
                                                        multiple={false}
                                                        accept=".jpg,.jpeg,.png,.pdf"
                                                        onChange={event =>
                                                          this.handleFileChange(
                                                            event,
                                                            setFieldValue
                                                          )
                                                        }
                                                        className={
                                                          "form-control" +
                                                          (errors.photo &&
                                                          touched.photo
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                      />
                                                      <small
                                                        style={{
                                                          color: "#007bff",
                                                        }}
                                                      >
                                                        Only JPEG, PNG, or PDF
                                                        files up to 2MB in size
                                                        are allowed.
                                                      </small>
                                                      <ErrorMessage
                                                        name="photo"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />

                                                      {/* 🔽 Add this below the input field */}
                                                      {this.state.selectedRow
                                                        ?.photo_url && (
                                                        <div className="mt-2">
                                                          <a
                                                            href={
                                                              this.state
                                                                .selectedRow
                                                                .photo_url
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-primary"
                                                          >
                                                            View Previously
                                                            Uploaded Pay Copy
                                                          </a>
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>

                                                  <Row>
                                                    <Col>
                                                      <Label>
                                                        Payment Method
                                                      </Label>
                                                      <Select
                                                        name="paymentmethod"
                                                        options={[
                                                          {
                                                            value: "Online",
                                                            label: "Online",
                                                          },
                                                          {
                                                            value: "Cheque",
                                                            label: "Cheque",
                                                          },
                                                          {
                                                            value: "Cash",
                                                            label: "Cash",
                                                          },
                                                        ]}
                                                        onChange={selectedOption =>
                                                          setFieldValue(
                                                            "paymentmethod",
                                                            selectedOption?.value ||
                                                              ""
                                                          )
                                                        }
                                                        value={
                                                          values.paymentmethod
                                                            ? {
                                                                value:
                                                                  values.paymentmethod,
                                                                label:
                                                                  values.paymentmethod,
                                                              }
                                                            : null
                                                        }
                                                        className={
                                                          errors.paymentmethod &&
                                                          touched.paymentmethod
                                                            ? "is-invalid"
                                                            : ""
                                                        }
                                                      />
                                                      <ErrorMessage
                                                        name="paymentmethod"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row>
                                                    <Col>
                                                      <Label>Received By</Label>
                                                      <Select
                                                        name="receivedby"
                                                        options={csrOptions}
                                                        placeholder="Select CSR"
                                                        onChange={selectedOption =>
                                                          setFieldValue(
                                                            "receivedby",
                                                            selectedOption?.value ||
                                                              ""
                                                          )
                                                        }
                                                        value={
                                                          values.receivedby
                                                            ? {
                                                                value:
                                                                  values.receivedby,
                                                                label:
                                                                  values.receivedby,
                                                              }
                                                            : null
                                                        }
                                                        className={
                                                          errors.receivedby &&
                                                          touched.receivedby
                                                            ? "is-invalid"
                                                            : ""
                                                        }
                                                      />
                                                      <ErrorMessage
                                                        name="receivedby"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mt-3">
                                                    <Col>
                                                      <Label>Comments</Label>
                                                      <Field name="csrcomments">
                                                        {({ field }) => (
                                                          <textarea
                                                            {...field}
                                                            rows={3}
                                                            className="form-control"
                                                            placeholder="Enter any additional comments"
                                                          />
                                                        )}
                                                      </Field>
                                                      <ErrorMessage
                                                        name="csrcomments"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </Col>
                                                  </Row>
                                                </>
                                              )}
                                            </Row>
                                          </Row>

                                          <div className="mt-4 text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-primary"
                                              disabled={isSubmitting}
                                            >
                                              Save Changes
                                            </button>
                                          </div>
                                        </Form>
                                      )}
                                    </Formik>
                                  )}
                                </ModalBody>
                              </Modal>
                              <Modal
                                isOpen={this.state.showDeleteModal}
                                toggle={this.handleCloseDeleteModal}
                                centered
                              >
                                <ModalHeader
                                  toggle={this.handleCloseDeleteModal}
                                >
                                  Delete Payment
                                </ModalHeader>
                                <ModalBody>
                                  <p>
                                    Are you sure you want to delete the payment
                                    record for{" "}
                                    <strong>
                                      {this.state.deleteParticipantName}
                                    </strong>
                                    ? This action cannot be undone.
                                  </p>

                                  <div className="mb-2">
                                    <Label
                                      for="deleteRequestedBy"
                                      className="fw-bold"
                                    >
                                      Requested By{" "}
                                      <span style={{ color: "#dc3545" }}>
                                        *
                                      </span>
                                    </Label>
                                    <Input
                                      id="deleteRequestedBy"
                                      type="text"
                                      placeholder="Name of the person who instructed this deletion"
                                      value={this.state.deleteRequestedBy || ""}
                                      onChange={e =>
                                        this.setState({
                                          deleteRequestedBy: e.target.value,
                                        })
                                      }
                                    />
                                  </div>

                                  <div className="mb-2">
                                    <Label
                                      for="deleteComment"
                                      className="fw-bold"
                                    >
                                      Reason for Deletion{" "}
                                      <span style={{ color: "#dc3545" }}>
                                        *
                                      </span>
                                    </Label>
                                    <textarea
                                      id="deleteComment"
                                      className="form-control"
                                      rows="3"
                                      placeholder="Enter reason for deleting this payment record..."
                                      value={this.state.deleteComment || ""}
                                      onChange={e =>
                                        this.setState({
                                          deleteComment: e.target.value,
                                        })
                                      }
                                    />
                                  </div>

                                  <div className="text-end mt-3">
                                    <Button
                                      color="secondary"
                                      size="sm"
                                      className="me-2"
                                      onClick={this.handleCloseDeleteModal}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      disabled={
                                        !this.state.deleteComment?.trim() ||
                                        !this.state.deleteRequestedBy?.trim()
                                      }
                                      onClick={this.handleConfirmDelete}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                </ModalBody>
                              </Modal>
                              <Modal
                                isOpen={this.state.showReplaceSchemeModal}
                                toggle={this.handleCloseReplaceSchemeModal}
                                centered
                              >
                                <ModalHeader
                                  toggle={this.handleCloseReplaceSchemeModal}
                                >
                                  Replace Scheme
                                  {this.state.replaceSchemeRow
                                    ?.participant_name
                                    ? ` – ${this.state.replaceSchemeRow.participant_name}`
                                    : ""}
                                </ModalHeader>
                                <ModalBody>
                                  <p className="text-muted">
                                    Swap one of this payment&apos;s active
                                    schemes for a different one. The retired
                                    scheme&apos;s payment history is kept, but
                                    it will no longer count toward upcoming
                                    rounds.
                                  </p>

                                  <div className="mb-3">
                                    <Label>Scheme to Replace</Label>
                                    <Select
                                      options={
                                        this.state.replaceSchemeActiveOptions
                                      }
                                      value={
                                        this.state.replaceSchemeActiveOptions.find(
                                          o =>
                                            o.value ===
                                            this.state.replaceSchemeOldId
                                        ) || null
                                      }
                                      onChange={selected =>
                                        this.setState({
                                          replaceSchemeOldId:
                                            selected?.value || "",
                                        })
                                      }
                                      placeholder="Select the current scheme to retire"
                                      isClearable
                                    />
                                  </div>

                                  <div className="mb-3">
                                    <Label>Replace With</Label>
                                    <Select
                                      options={
                                        this.state.replaceSchemeNewOptions
                                      }
                                      value={
                                        this.state.replaceSchemeNewOptions.find(
                                          o =>
                                            o.value ===
                                            this.state.replaceSchemeNewId
                                        ) || null
                                      }
                                      onChange={selected =>
                                        this.setState({
                                          replaceSchemeNewId:
                                            selected?.value || "",
                                        })
                                      }
                                      placeholder="Select the new scheme"
                                      isClearable
                                    />
                                  </div>

                                  {/* ================= Existing Receipt / Pay Copy ================= */}
                                  <div className="mb-3">
                                    <Label>Payment Receipt</Label>
                                    <div className="mb-2">
                                      {this.state.replaceSchemeRow?.photo_url ? (
                                        <a
                                          href={this.state.replaceSchemeRow.photo_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="text-primary"
                                        >
                                          View Uploaded Pay Copy
                                        </a>
                                      ) : (
                                        <span className="text-muted">
                                          No receipt uploaded for this payment
                                        </span>
                                      )}
                                    </div>
                                    <Input
                                      id="replaceSchemePhoto"
                                      type="file"
                                      accept=".jpg,.jpeg,.png,.pdf"
                                      onChange={e =>
                                        this.setState({
                                          replaceSchemePhoto:
                                            e.target.files[0] || null,
                                        })
                                      }
                                    />
                                    <small style={{ color: "#007bff" }}>
                                      Only JPEG, PNG, or PDF files up to 2MB.
                                      Leave empty to keep the existing receipt.
                                    </small>
                                  </div>

                                  {/* ================= Payable / Discount / Tax ================= */}
                                  <div className="mb-3">
                                    <Label>Payable (Before Discount)</Label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={this.formatNumber(
                                        replaceSchemeTotals.priceBeforeDiscount
                                      )}
                                      readOnly
                                      style={{ backgroundColor: "#e9ecef" }}
                                    />
                                  </div>

                                  <Row>
                                    <Col md={6}>
                                      <Label>Discount Amount (Rs)</Label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={
                                          this.state.replaceSchemeDiscountAmount
                                        }
                                        onChange={e =>
                                          this.setState({
                                            replaceSchemeDiscountAmount:
                                              e.target.value,
                                          })
                                        }
                                      />
                                    </Col>
                                    <Col md={6}>
                                      <Label>Tax Deduction</Label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={
                                          this.state.replaceSchemeTaxDeduction
                                        }
                                        onChange={e =>
                                          this.setState({
                                            replaceSchemeTaxDeduction:
                                              e.target.value,
                                          })
                                        }
                                      />
                                    </Col>
                                  </Row>

                                  <div className="mb-3 mt-2">
                                    <Label>Final Payable</Label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={this.formatNumber(
                                        replaceSchemeTotals.finalPrice
                                      )}
                                      readOnly
                                      style={{ backgroundColor: "#e9ecef" }}
                                    />
                                  </div>

                                  {/* ================= Payment Status ================= */}
                                  <div className="mb-3">
                                    <Label>Payment Status</Label>
                                    <Select
                                      options={[
                                        { value: "Paid", label: "Paid" },
                                        {
                                          value: "Payment In process",
                                          label: "Payment In process",
                                        },
                                      ]}
                                      value={
                                        this.state.replaceSchemePaymentStatus
                                          ? {
                                              value:
                                                this.state
                                                  .replaceSchemePaymentStatus,
                                              label:
                                                this.state
                                                  .replaceSchemePaymentStatus,
                                            }
                                          : null
                                      }
                                      onChange={selected =>
                                        this.setState({
                                          replaceSchemePaymentStatus:
                                            selected?.value || "",
                                        })
                                      }
                                      placeholder="Select Payment Status"
                                      isClearable
                                    />
                                  </div>

                                  {this.state.replaceSchemePaymentStatus ===
                                    "Paid" && (
                                    <>
                                      {/* ================= Payment Settlement ================= */}
                                      <div className="mb-3">
                                        <Label>Payment Settlement</Label>
                                        <Select
                                          options={[
                                            { value: "Full", label: "Full" },
                                            { value: "Part", label: "Part" },
                                          ]}
                                          value={
                                            this.state
                                              .replaceSchemePaymentSettlement
                                              ? {
                                                  value:
                                                    this.state
                                                      .replaceSchemePaymentSettlement,
                                                  label:
                                                    this.state
                                                      .replaceSchemePaymentSettlement,
                                                }
                                              : null
                                          }
                                          onChange={selected => {
                                            const settlement =
                                              selected?.value || "";
                                            const { finalPrice } =
                                              this.getReplaceSchemeTotals();

                                            if (settlement === "Full") {
                                              this.setState({
                                                replaceSchemePaymentSettlement:
                                                  settlement,
                                                replaceSchemePartPaymentAmount: finalPrice.toFixed(
                                                  2
                                                ),
                                                replaceSchemeRemainingAmount: 0,
                                              });
                                            } else {
                                              this.setState({
                                                replaceSchemePaymentSettlement:
                                                  settlement,
                                              });
                                            }
                                          }}
                                          placeholder="Select"
                                          isClearable
                                        />
                                      </div>

                                      {/* ================= Paid Amount ================= */}
                                      <Row>
                                        <Col md={6}>
                                          <Label>Paid Amount</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            readOnly={
                                              this.state
                                                .replaceSchemePaymentSettlement ===
                                              "Full"
                                            }
                                            style={
                                              this.state
                                                .replaceSchemePaymentSettlement ===
                                              "Full"
                                                ? { backgroundColor: "#e9ecef" }
                                                : {}
                                            }
                                            value={
                                              this.state
                                                .replaceSchemePartPaymentAmount
                                            }
                                            onChange={e => {
                                              const input = e.target.value;
                                              const partAmount =
                                                parseFloat(input) || 0;
                                              const { finalPrice } =
                                                this.getReplaceSchemeTotals();
                                              const remaining =
                                                finalPrice - partAmount;

                                              this.setState({
                                                replaceSchemePartPaymentAmount:
                                                  input,
                                                replaceSchemeRemainingAmount:
                                                  remaining >= 0
                                                    ? remaining
                                                    : 0,
                                              });
                                            }}
                                          />
                                        </Col>

                                        {this.state
                                          .replaceSchemePaymentSettlement ===
                                          "Part" && (
                                          <Col md={6}>
                                            <Label>Remaining Amount</Label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              readOnly
                                              style={{
                                                backgroundColor: "#e9ecef",
                                              }}
                                              value={this.formatNumber(
                                                this.state
                                                  .replaceSchemeRemainingAmount
                                              )}
                                            />
                                          </Col>
                                        )}
                                      </Row>

                                      {/* ================= Pay Date ================= */}
                                      <div className="mb-3 mt-3">
                                        <Label>Pay Date</Label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          value={
                                            this.state.replaceSchemePayDate
                                          }
                                          onChange={e =>
                                            this.setState({
                                              replaceSchemePayDate:
                                                e.target.value,
                                            })
                                          }
                                        />
                                      </div>

                                      {/* ================= Payment Method ================= */}
                                      <div className="mb-3">
                                        <Label>Payment Method</Label>
                                        <Select
                                          options={[
                                            {
                                              value: "Online",
                                              label: "Online",
                                            },
                                            {
                                              value: "Cheque",
                                              label: "Cheque",
                                            },
                                            { value: "Cash", label: "Cash" },
                                          ]}
                                          value={
                                            this.state
                                              .replaceSchemePaymentMethod
                                              ? {
                                                  value:
                                                    this.state
                                                      .replaceSchemePaymentMethod,
                                                  label:
                                                    this.state
                                                      .replaceSchemePaymentMethod,
                                                }
                                              : null
                                          }
                                          onChange={selected =>
                                            this.setState({
                                              replaceSchemePaymentMethod:
                                                selected?.value || "",
                                            })
                                          }
                                          placeholder="Select"
                                          isClearable
                                        />
                                      </div>
                                    </>
                                  )}

                                  {/* ================= Received By (CSR) ================= */}
                                  <div className="mb-3">
                                    <Label>Received By (CSR)</Label>
                                    <Select
                                      options={csrOptions}
                                      value={
                                        this.state.replaceSchemeCSR
                                          ? {
                                              value:
                                                this.state.replaceSchemeCSR,
                                              label:
                                                this.state.replaceSchemeCSR,
                                            }
                                          : null
                                      }
                                      onChange={selected =>
                                        this.setState({
                                          replaceSchemeCSR:
                                            selected?.value || "",
                                        })
                                      }
                                      placeholder="Select CSR"
                                      isClearable
                                    />
                                  </div>

                                  {/* ================= Comments ================= */}
                                  <div className="mb-3">
                                    <Label>Comments</Label>
                                    <textarea
                                      className="form-control"
                                      rows={3}
                                      placeholder="Enter any comments regarding this scheme replacement"
                                      value={this.state.replaceSchemeComments}
                                      onChange={e =>
                                        this.setState({
                                          replaceSchemeComments:
                                            e.target.value,
                                        })
                                      }
                                    />
                                  </div>

                                  <div className="text-end mt-3">
                                    <Button
                                      color="secondary"
                                      size="sm"
                                      className="me-2"
                                      onClick={this.handleCloseReplaceSchemeModal}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      color="primary"
                                      size="sm"
                                      disabled={
                                        !this.state.replaceSchemeOldId ||
                                        !this.state.replaceSchemeNewId
                                      }
                                      onClick={this.handleConfirmReplaceScheme}
                                    >
                                      Confirm Replace
                                    </Button>
                                  </div>
                                </ModalBody>
                              </Modal>
                              <Row className="mb-3">
                                <Col md={12} className="text-end">
                                  <Button
                                    onClick={this.exportToExcel}
                                    className="mb-3"
                                  >
                                    Export to Excel
                                  </Button>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col md={4}>
                                  <Label for="nameFilter">
                                    Participant Name
                                  </Label>
                                  <Select
                                    id="nameFilter"
                                    options={[
                                      {
                                        value: "All",
                                        label: "All Participants",
                                      },
                                      ...this.getUniqueOptions(
                                        "participant_name"
                                      ).map(option => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.nameFilter
                                        ? {
                                            value: this.state.nameFilter,
                                            label: this.state.nameFilter,
                                          }
                                        : null
                                    }
                                    onChange={selected =>
                                      this.handleFilterChange("nameFilter", {
                                        target: {
                                          value: selected?.value || "",
                                        },
                                      })
                                    }
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label>Scheme</Label>
                                  <Select
                                    options={[
                                      { value: "All", label: "All Schemes" },
                                      ...schemeOptionsFromData.map(name => ({
                                        value: name,
                                        label: name,
                                      })),
                                    ]}
                                    value={
                                      this.state.schemeFilter
                                        ? {
                                            value: this.state.schemeFilter,
                                            label: this.state.schemeFilter,
                                          }
                                        : null
                                    }
                                    onChange={selected =>
                                      this.handleFilterChange("schemeFilter", {
                                        target: {
                                          value: selected?.value || "",
                                        },
                                      })
                                    }
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="districtFilter">District</Label>
                                  <Select
                                    id="districtFilter"
                                    options={[
                                      { value: "All", label: "All Districts" },
                                      ...this.getUniqueOptions("district").map(
                                        option => ({
                                          value: option,
                                          label: option,
                                        })
                                      ),
                                    ]}
                                    value={
                                      this.state.districtFilter
                                        ? {
                                            value: this.state.districtFilter,
                                            label: this.state.districtFilter,
                                          }
                                        : null
                                    }
                                    onChange={selected =>
                                      this.handleFilterChange(
                                        "districtFilter",
                                        {
                                          target: {
                                            value: selected?.value || "",
                                          },
                                        }
                                      )
                                    }
                                    isClearable
                                  />
                                </Col>
                                <Col md={4}>
                                  <Label for="paymentsettlementFilter">
                                    Payment Settlement
                                  </Label>
                                  <Select
                                    id="paymentsettlementFilter"
                                    options={[
                                      {
                                        value: "All",
                                        label: "All Payment Settlement",
                                      },
                                      ...this.getUniqueOptions(
                                        "payment_settlement"
                                      ).map(option => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.paymentsettlementFilter
                                        ? {
                                            value:
                                              this.state
                                                .paymentsettlementFilter,
                                            label:
                                              this.state
                                                .paymentsettlementFilter,
                                          }
                                        : null
                                    }
                                    onChange={selected =>
                                      this.handleFilterChange(
                                        "paymentsettlementFilter",
                                        {
                                          target: {
                                            value: selected?.value || "",
                                          },
                                        }
                                      )
                                    }
                                    isClearable
                                    styles={{
                                      control: provided => ({
                                        ...provided,
                                        backgroundColor: "#d0e2ff",
                                      }),
                                    }}
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="paymentStatusFilter">
                                    Payment Status
                                  </Label>
                                  <Select
                                    id="paymentStatusFilter"
                                    options={[
                                      {
                                        value: "All",
                                        label: "All Payment Statuses",
                                      },
                                      ...this.getUniqueOptions(
                                        "payment_status"
                                      ).map(option => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.paymentStatusFilter
                                        ? {
                                            value:
                                              this.state.paymentStatusFilter,
                                            label:
                                              this.state.paymentStatusFilter,
                                          }
                                        : null
                                    }
                                    onChange={selected =>
                                      this.handleFilterChange(
                                        "paymentStatusFilter",
                                        {
                                          target: {
                                            value: selected?.value || "",
                                          },
                                        }
                                      )
                                    }
                                    isClearable
                                    styles={{
                                      control: provided => ({
                                        ...provided,
                                        backgroundColor: "#d0e2ff",
                                      }),
                                    }}
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="reconcileStatusFilter">
                                    Verification Status
                                  </Label>
                                  <Select
                                    id="reconcileStatusFilter"
                                    options={[
                                      {
                                        value: "All",
                                        label: "All Payment Statuses",
                                      },
                                      ...this.getUniqueOptions(
                                        "payment_reconcile_status"
                                      ).map(option => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.reconcileStatusFilter
                                        ? {
                                            value:
                                              this.state.reconcileStatusFilter,
                                            label:
                                              this.state.reconcileStatusFilter,
                                          }
                                        : null
                                    }
                                    onChange={selected =>
                                      this.handleFilterChange(
                                        "reconcileStatusFilter",
                                        {
                                          target: {
                                            value: selected?.value || "",
                                          },
                                        }
                                      )
                                    }
                                    isClearable
                                  />
                                </Col>
                                <Row>
                                  <Col md={3}>
                                    <Label for="dateFrom">Payment Date</Label>
                                    <input
                                      type="date"
                                      id="dateFrom"
                                      className="form-control"
                                      value={this.state.dateFrom}
                                      onChange={e =>
                                        this.setState(
                                          { dateFrom: e.target.value },
                                          this.checkFiltersApplied
                                        )
                                      }
                                    />
                                  </Col>

                                  <Col md={3}>
                                    <Label for="dateTo">Date To</Label>
                                    <input
                                      type="date"
                                      id="dateTo"
                                      className="form-control"
                                      value={this.state.dateTo}
                                      onChange={e =>
                                        this.setState(
                                          {
                                            dateTo: e.target.value,
                                            dateToActive: true,
                                          },
                                          this.checkFiltersApplied
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                              </Row>
                              <Row className="mb-2 mt-3"></Row>
                              <Modal
                                isOpen={this.state.showReconcileModal}
                                toggle={this.handleCloseModal}
                                centered
                                size="xl"
                              >
                                <ModalHeader toggle={this.handleCloseModal}>
                                  Verification Status –{" "}
                                  {this.state.activeParticipantName}
                                </ModalHeader>

                                <ModalBody>
                                  {this.getVerifiedPaymentsForParticipant()
                                    .length > 0 && (
                                    <>
                                      <h5 className="fw-bold text-dark mb-2">
                                        Details of Previous Verified Payments
                                      </h5>

                                      {/* ===== Fixed Table Section ===== */}
                                      <div
                                        style={{
                                          maxHeight: "190px",
                                          overflowY: "auto",
                                          marginBottom: "12px",
                                        }}
                                      >
                                        <table className="table table-bordered table-sm text-nowrap mb-0">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "13px" }}>
                                              <th className="text-center">
                                                Payment ID
                                              </th>
                                              <th>Payment Date</th>
                                              <th className="text-end">
                                                Paid Amount
                                              </th>
                                              <th className="text-center">
                                                Verification Status
                                              </th>
                                              <th>Verification Date</th>
                                              <th>
                                                Bank Credit / Transaction Date
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody style={{ fontSize: "13px" }}>
                                            {this.getVerifiedPaymentsForParticipant()
                                              .length > 0 ? (
                                              this.getVerifiedPaymentsForParticipant().map(
                                                (pay, index) => {
                                                  const formatDate = date =>
                                                    date
                                                      ? `${String(
                                                          new Date(
                                                            date
                                                          ).getDate()
                                                        ).padStart(
                                                          2,
                                                          "0"
                                                        )}-${new Date(
                                                          date
                                                        ).toLocaleString(
                                                          "en-GB",
                                                          {
                                                            month: "short",
                                                          }
                                                        )}-${String(
                                                          new Date(
                                                            date
                                                          ).getFullYear()
                                                        ).slice(-2)}`
                                                      : "-";

                                                  return (
                                                    <tr key={index}>
                                                      <td className="text-center fw-semibold">
                                                        {pay.id || "-"}
                                                      </td>
                                                      <td>
                                                        {formatDate(
                                                          pay.paydate
                                                        )}
                                                      </td>
                                                      <td className="text-end">
                                                        {this.formatNumber(
                                                          pay.price
                                                        )}
                                                      </td>
                                                      <td
                                                        className="text-center"
                                                        style={{
                                                          color:
                                                            pay.payment_reconcile_status ===
                                                            "Verified"
                                                              ? "green"
                                                              : "red",
                                                          fontWeight: 600,
                                                        }}
                                                      >
                                                        {pay.payment_reconcile_status ||
                                                          "Non-Verified"}
                                                      </td>
                                                      <td>
                                                        {formatDate(
                                                          pay.reconciled_at
                                                        )}
                                                      </td>
                                                      <td>
                                                        {formatDate(
                                                          pay.payment_received_date
                                                        )}
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="6"
                                                  className="text-center text-muted"
                                                >
                                                  No verified payments for this
                                                  Lab
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                      <hr className="my-3" />
                                    </>
                                  )}
                                  {/* ===== New Payment Table ===== */}
                                  {filteredSchemes.length > 0 && (
                                    <>
                                      <h5 className="fw-bold text-dark mb-2">
                                        New Payment to be Verified
                                      </h5>

                                      <div className="mb-3">
                                        <table className="table table-bordered table-sm text-nowrap mb-0">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "13px" }}>
                                              <th className="text-center">
                                                Payment ID
                                              </th>
                                              <th>Payment Date</th>
                                              <th className="text-end">
                                                Paid Amount
                                              </th>
                                              <th>Verification Status</th>
                                              <th>Verification Date</th>
                                              <th>Bank / Transaction Date</th>
                                            </tr>
                                          </thead>

                                          <tbody style={{ fontSize: "13px" }}>
                                            {/* 
    We only need ONE row per payment.
    Even if this payment has multiple schemes,
    we must NOT loop over schemes here.
  */}

                                            {filteredSchemes.length > 0 &&
                                              (() => {
                                                // Format payment date safely
                                                const payDate = this.state
                                                  .activeRowPaymentDate
                                                  ? new Date(
                                                      this.state.activeRowPaymentDate
                                                    )
                                                  : null;

                                                const formattedDate = payDate
                                                  ? `${String(
                                                      payDate.getDate()
                                                    ).padStart(
                                                      2,
                                                      "0"
                                                    )}-${payDate.toLocaleString(
                                                      "en-GB",
                                                      { month: "short" }
                                                    )}-${String(
                                                      payDate.getFullYear()
                                                    ).slice(-2)}`
                                                  : "-";

                                                return (
                                                  <tr>
                                                    {/* Payment ID (shown once) */}
                                                    <td className="text-center fw-semibold">
                                                      {this.state
                                                        .activeRowPaymentId ||
                                                        "-"}
                                                    </td>

                                                    {/* Payment Date */}
                                                    <td>{formattedDate}</td>

                                                    {/* Paid Amount */}
                                                    <td className="text-end">
                                                      {this.state
                                                        .activeRowPaidAmount ||
                                                        "-"}
                                                    </td>

                                                    {/* Verification Status */}
                                                    <td
                                                      style={{
                                                        color:
                                                          this.state
                                                            .activeRowPaymentStatus ===
                                                          "Verified"
                                                            ? "green"
                                                            : "red",
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {this.state
                                                        .activeRowPaymentStatus ||
                                                        "Non-Verified"}
                                                    </td>

                                                    {/* Verification Date (not yet available for new payment) */}
                                                    <td>-</td>

                                                    {/* Bank / Transaction Date */}
                                                    <td>
                                                      {this.state
                                                        .paymentReceivedDate ||
                                                        "-"}
                                                    </td>
                                                  </tr>
                                                );
                                              })()}
                                          </tbody>
                                        </table>
                                      </div>
                                    </>
                                  )}

                                  {/* ===== Summary ===== */}
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginBottom: "12px",
                                    }}
                                  >
                                    <b>Final Payable:</b>{" "}
                                    {this.state.activeRowPayable || "-"} &nbsp;
                                    | &nbsp;
                                    <b>Payment Mode:</b>{" "}
                                    {this.state.activeRowPaymentMode || "-"}
                                  </div>

                                  {/* ===== Verification Form ===== */}
                                  <div className="mb-2">
                                    <Select
                                      options={[
                                        {
                                          value: "Verified",
                                          label: "Verified",
                                        },
                                        {
                                          value: "Non-Verified",
                                          label: "Non-Verified",
                                        },
                                      ]}
                                      value={
                                        this.state.pendingReconcileStatus
                                          ? {
                                              value:
                                                this.state
                                                  .pendingReconcileStatus,
                                              label:
                                                this.state
                                                  .pendingReconcileStatus,
                                            }
                                          : null
                                      }
                                      onChange={selected =>
                                        this.setState({
                                          pendingReconcileStatus: selected
                                            ? selected.value
                                            : null,
                                          // ❌ DO NOT reset pending values here
                                        })
                                      }
                                      placeholder="Select Verification Status"
                                      isClearable
                                    />
                                  </div>

                                  {this.state.pendingReconcileStatus ===
                                    "Verified" && (
                                    <>
                                      {/* ================= Account Number ================= */}
                                      <div className="mb-2">
                                        <label className="fw-bold">
                                          Select Account Number
                                        </label>

                                        <Select
                                          options={(
                                            this.props.ListBank || []
                                          ).map(bank => ({
                                            value: bank.account_number,
                                            label: `${bank.account_number} (${bank.name})`,
                                          }))}
                                          value={
                                            this.state
                                              .pendingSelectedAccountNumber
                                              ? {
                                                  value:
                                                    this.state
                                                      .pendingSelectedAccountNumber,
                                                  label: `${this.state.pendingSelectedAccountNumber} (${this.state.pendingBankName})`,
                                                }
                                              : null
                                          }
                                          onChange={selected =>
                                            this.setState({
                                              pendingSelectedAccountNumber:
                                                selected?.value || "",
                                              pendingBankName:
                                                selected?.label
                                                  ?.split(" (")[1]
                                                  ?.replace(")", "") || "",
                                            })
                                          }
                                          placeholder="Select Account"
                                          isClearable
                                        />
                                      </div>

                                      {/* ================= Bank Credit Date ================= */}

                                      {!isAlreadyVerified && (
                                        <div className="mb-2">
                                          <label className="fw-bold">
                                            Bank Credit / Transaction Date
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            max={
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            value={
                                              this.state
                                                .pendingPaymentReceivedDate ||
                                              ""
                                            }
                                            onChange={e =>
                                              this.setState({
                                                pendingPaymentReceivedDate:
                                                  e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      )}

                                      {/* ================= Attachment ================= */}
                                      <div className="mb-2">
                                        <label className="fw-bold">
                                          Attach Image
                                        </label>

                                        {/* Existing attachment (for already verified payments) */}
                                        {this.state.pendingUploadedImage &&
                                          typeof this.state
                                            .pendingUploadedImage ===
                                            "string" && (
                                            <div className="mb-1">
                                              <a
                                                href={
                                                  this.state
                                                    .pendingUploadedImage
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                View Existing Attachment
                                              </a>
                                            </div>
                                          )}

                                        <input
                                          type="file"
                                          className="form-control"
                                          accept="image/*"
                                          onChange={e =>
                                            this.setState({
                                              pendingUploadedImage:
                                                e.target.files[0],
                                            })
                                          }
                                        />
                                      </div>

                                      {/* ================= Comments ================= */}
                                      <div className="mb-2">
                                        <label className="fw-bold">
                                          Add Comments
                                        </label>

                                        <textarea
                                          className="form-control"
                                          rows="2"
                                          placeholder="Enter any comments..."
                                          value={
                                            this.state.pendingComments || ""
                                          }
                                          onChange={e =>
                                            this.setState({
                                              pendingComments: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </>
                                  )}

                                  <div className="text-end mt-3">
                                    <div className="text-end mt-3">
                                      <Button
                                        color="primary"
                                        size="sm"
                                        disabled={
                                          this.state.pendingReconcileStatus !==
                                            "Verified" ||
                                          (!this.state
                                            .pendingSelectedAccountNumber &&
                                            this.state.activeRowPayable > 0) ||
                                          !this.state.pendingPaymentReceivedDate
                                        }
                                        onClick={this.handleReconcileSubmit}
                                      >
                                        Verify
                                      </Button>
                                    </div>
                                  </div>
                                </ModalBody>
                              </Modal>

                              <Modal
                                isOpen={this.state.showReconcileDetailsModal}
                                toggle={() =>
                                  this.setState({
                                    showReconcileDetailsModal: false,
                                  })
                                }
                                centered
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({
                                      showReconcileDetailsModal: false,
                                    })
                                  }
                                >
                                  Verification Details –{" "}
                                  {this.state.selectedPayment?.participant_name}
                                </ModalHeader>

                                <ModalBody>
                                  {this.state.selectedPayment ? (
                                    <table className="table table-bordered table-striped">
                                      <tbody>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Status</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .payment_reconcile_status || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Account Number</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .account_number || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Bank Name</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .bank_name || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Bank Credit Date</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .payment_received_date
                                              ? new Date(
                                                  this.state.selectedPayment.payment_received_date
                                                ).toLocaleDateString("en-GB", {
                                                  day: "2-digit",
                                                  month: "short",
                                                  year: "numeric",
                                                })
                                              : "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Comments</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .comments || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Attachment</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              ?.attachment_url ? (
                                              <a
                                                href={
                                                  this.state.selectedPayment
                                                    .attachment_url
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                View Attachment
                                              </a>
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                        </tr>

                                        <tr>
                                          <td className="text-start">
                                            <strong>Verified By</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .added_by_name || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Verified At</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .reconciled_at
                                              ? new Date(
                                                  this.state.selectedPayment.reconciled_at
                                                ).toLocaleDateString("en-GB", {
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                })
                                              : "-"}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  ) : (
                                    <p>No details found.</p>
                                  )}
                                </ModalBody>
                              </Modal>
                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      key={this.state.tableKey}
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={"table align-middle"}
                                      bordered={false}
                                      striped={false}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantPayments.propTypes = {
  GetPayment: PropTypes.array,
  onGetParticipantpayment: PropTypes.func,
  CycleList: PropTypes.array,
  onGetParticipantpayment: PropTypes.func,
  confirmpayment: PropTypes.array,
  onconfirmpayment: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  ongetcyclelist: PropTypes.func,
  match: PropTypes.object,
  onupdatePayment: PropTypes.func,
  ListDistrict: PropTypes.array,
  onGetDistrictList: PropTypes.func,
  ondeletePayment: PropTypes.func,
  ListBank: PropTypes.array,
  PaymentSchemeList: PropTypes.array,
  CSRList: PropTypes.array,
  onGetParticipantSchemelist: PropTypes.func,
  onGetBankList: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = state => {
  const cycleList = state.CycleList?.CycleList || [];
  const ListDistrict = state.ListDistrict?.ListDistrict || [];

  console.log("CycleList:", cycleList);
  console.log("ListDistrict:", ListDistrict);

  return {
    userID: state.Account?.userID || null,
    CycleList: cycleList,
    PaymentSchemeList: state.PaymentScheme?.PaymentSchemeList || [],
    GetPayment: state.AddPayment?.GetPayment ?? [],
    ListBank: state.banks.ListBank,
    ListDistrict, // ✅ Now correctly passing the declared ListDistrict
    PaymentSchemeList: state.AddPayment?.PaymentSchemeList || [], // 👈 added
    CSRList: state.AddPayment?.csr_staff || [], // 👈 added
  };
};

const mapDispatchToProps = dispatch => ({
  //  onGetParticipantpayment: () => dispatch(getParticipantPayment()),
  onGetParticipantpayment: id => dispatch(getParticipantPayment(id)),
  ongetcyclelist: id => dispatch(getcyclelist(id)),
  onupdatePayment: payload => dispatch(updatePayment(payload)),
  onGetDistrictList: id => dispatch(getdistrictlist(id)),
  confirmpayment: id => dispatch(confirmpayment(id)),
  onGetBankList: id => dispatch(getbanklist(id)),
  ondeletePayment: payload => dispatch(deletePayment(payload)),
  onGetParticipantSchemelist: id => dispatch(getParticipantSchemelist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipantPayments);